import React, {  useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables"; 
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress'; 
import DeleteIcon from '@mui/icons-material/Delete'; 
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; 
import IconButton from '@mui/material/IconButton'; 
import makeStyles from '@mui/styles/makeStyles'; 
import SearchIcon from '@mui/icons-material/Search'; 
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import { NumericFormat } from 'components/utils/NumericFormat';
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import NTCreateOrEditOptTras  from "pages/NT/editOrCreateNT/NTOptTrasEdit";
import NTCreateOrEditOriTras  from "pages/NT/editOrCreateNT/NTOriTrasEdit";
import NTCreateOrEditAutTras  from "pages/NT/editOrCreateNT/NTAutTrasEdit";
import NTCreateOrEditDestTras from "pages/NT/editOrCreateNT/NTDestTrasEdit";
import NTCreateOrEditAutDest  from "pages/NT/editOrCreateNT/NTAutDestEdit";
import NTSearchCodeLers  from "pages/NT/editOrCreateNT/NTSearchCodeLers";
import NTSearchDescriptions  from "pages/NT/editOrCreateNT/NTSearchDescriptions";
import NTCreateOrEditRelTrans  from "pages/NT/editOrCreateNT/NTRelTransEdit";
import NTCreateOrEditRespProd  from "pages/NT/editOrCreateNT/NTRespProdEdit"; 

const initialStateNT = {
  "id" : "",
  "ownformnt_id" : "", 
  "defaultStore_id":0, 
  "useraccount_id":0,

  "defaultformatnumber":1,
  "isFinished":true,
  "isScanned":false,
  "preiddoc_sheet" : "",
  "sufiddoc_sheet" : 0,

  "number_nt":"",
  "init_date_nt":"",
  "end_date_nt":"",
  "isindividual":false,
  "ismultiple":true,
  "frecuency":"Bajo petición",
  "number_nt_refused":"",
  "isemergency":false,
  "reason_emergency":"",
   
  "formopttrasstore_id": 0,
  "opt_tras_store_id" : 0,
  "opt_tras_documnettype_id" : 1,
  "opt_tras_documentid" : "",
  "opt_tras_tradename" : "",
  "opt_tras_name" : "",
  "opt_tras_contactname" : "",
  "opt_tras_roadtype_id" :  74,
  "opt_tras_street" : "",
  "opt_tras_country_id":  1,
  "opt_tras_country_name": "",
  "opt_tras_province_id": 30,
  "opt_tras_province_name": "",
  "opt_tras_postalcode_id": 6911,
  "opt_tras_postalcode_code":"",
  "opt_tras_postalcode_name": "",
  "opt_tras_community_id":  6, 
  "opt_tras_community_name": "",
  "opt_tras_phone":"",
  "opt_tras_email":"",
  "opt_tras_nima":"",
  "opt_tras_cnae":"",
  "opt_tras_inscription":"",
  "opt_tras_opt":0,
  "opt_tras_licenseplate":"",
  "opt_tras_economicactivity":"",
  
  "formoritrasstore_id": 0,
  "ori_tras_store_id" : 0,
  "ori_tras_documnettype_id" :1,
  "ori_tras_documentid" : "",
  "ori_tras_tradename" : "",
  "ori_tras_name" : "",
  "ori_tras_contactname" : "",
  "ori_tras_roadtype_id" :  74,
  "ori_tras_street" : "",
  "ori_tras_country_id": 1,
  "ori_tras_country_name": "",
  "ori_tras_province_id": 30,
  "ori_tras_province_name": "",
  "ori_tras_postalcode_id": 6911,
  "ori_tras_postalcode_code": "",
  "ori_tras_postalcode_name": "",
  "ori_tras_community_id": 6,
  "ori_tras_community_name": "",
  "ori_tras_phone":"",
  "ori_tras_email":"",
  "ori_tras_nima":"",
  "ori_tras_cnae":"",
  "ori_tras_inscription":"",
  "ori_tras_opt":0,
  "ori_tras_licenseplate":"",
  "ori_tras_economicactivity":"",
  
  "aut_tras_store_id" : 0,
  "aut_tras_documnettype_id" : 1,
  "aut_tras_documentid" : "",
  "aut_tras_tradename" : "",
  "aut_tras_name" : "",
  "aut_tras_contactname" : "",
  "aut_tras_roadtype_id" : 74,
  "aut_tras_street" : "",
  "aut_tras_country_id": 1,
  "aut_tras_country_name": "",
  "aut_tras_province_id": 30,
  "aut_tras_province_name": "",
  "aut_tras_postalcode_id": 6911,
  "aut_tras_postalcode_code": "",
  "aut_tras_postalcode_name": "",
  "aut_tras_community_id": 6,
  "aut_tras_community_name": "",
  "aut_tras_phone":"",
  "aut_tras_email":"",
  "aut_tras_nima":"",
  "aut_tras_cnae":"",
  "aut_tras_inscription":"",
  "aut_tras_opt":0,
  "aut_tras_licenseplate":"",
  "aut_tras_economicactivity":"",
  
  "formdesttrasstore_id": 0,
  "dest_tras_store_id" : 0,
  "dest_tras_documnettype_id" :1,
  "dest_tras_documentid" : "",
  "dest_tras_tradename" : "",
  "dest_tras_name" : "",
  "dest_tras_contactname" : "",
  "dest_tras_roadtype_id" : 74,
  "dest_tras_street" : "",
  "dest_tras_country_id": 1,
  "dest_tras_country_name": "",
  "dest_tras_province_id": 30,
  "dest_tras_province_name": "",
  "dest_tras_postalcode_id":6911,
  "dest_tras_postalcode_code": "",
  "dest_tras_postalcode_name": "",
  "dest_tras_community_id": 6,
  "dest_tras_community_name": "",
  "dest_tras_phone":"",
  "dest_tras_email":"",
  "dest_tras_nima":"",
  "dest_tras_cnae":"",
  "dest_tras_inscription":"",
  "dest_tras_opt":0,
  "dest_tras_licenseplate":"",
  "dest_tras_economicactivity":"",
 
  "aut_dest_store_id" : 0,
  "aut_dest_documnettype_id" :1,
  "aut_dest_documentid" : "",
  "aut_dest_tradename" : "",
  "aut_dest_name" : "",
  "aut_dest_contactname" : "",
  "aut_dest_roadtype_id" : 74,
  "aut_dest_street" : "",
  "aut_dest_country_id": 1,
  "aut_dest_country_name":"",
  "aut_dest_province_id": 30,
  "aut_dest_province_name":"",
  "aut_dest_postalcode_id": 6911,
  "aut_dest_postalcode_code":"",
  "aut_dest_postalcode_name":"",
  "aut_dest_community_id": 6,
  "aut_dest_community_name":"",
  "aut_dest_phone":"",
  "aut_dest_email":"",
  "aut_dest_nima":"",
  "aut_dest_cnae":"",
  "aut_dest_inscription":"",
  "aut_dest_opt":0,
  "aut_dest_licenseplate":"",
  "aut_dest_economicactivity":"",

  "codeler_id" : 0,
  "codeler_code" : "",
  "codeler_namees" : "",
  "codeler_nameen" : "",
  "description_id" : 0,
  "description_code" : "",
  "description_namees" : "",
  "description_nameen" : "",
  
  "treatmenttypeorigin_id" : 0,
  "treatmenttypeorigin_code" : "",
  "treatmenttypeorigin_namees" : "",
  "treatmenttypeorigin_nameen" : "",
 
  "treatmenttypedestine_id" : 0,
  "treatmenttypedestine_code" : "",
  "treatmenttypedestine_namees" : "",
  "treatmenttypedestine_nameen" : "",
  
  "processtypepeorigin_id" : 0,
  "processtypepeorigin_code" : "",
  "processtypepeorigin_namees" : "",
  "processtypepeorigin_nameen" : "",

  "processtypedestine_id" : 0,
  "processtypedestine_code" : "",
  "processtypedestine_namees" : "",
  "processtypedestine_nameen" : "",
  
  "dangerousness_id" : 0,
  "dangerousness_namees" : "",
  "dangerousness_nameen" : "",

  "charac_danger" : "",
  "amount" : 0,

  "formreltransstore_id": 0,
  "rel_trans_store_id" : 0,
  "rel_trans_documnettype_id" : 0,
  "rel_trans_documentid" : "",
  "rel_trans_tradename" : "",
  "rel_trans_name" : "",
  "rel_trans_contactname" : "",
  "rel_trans_roadtype_id" :  0,
  "rel_trans_street" : "",
  "rel_trans_country_id": 0,
  "rel_trans_country_name" : "",
  "rel_trans_province_id": 0,
  "rel_trans_province_name" : "",
  "rel_trans_postalcode_id":0,
  "rel_trans_postalcode_code" : "",
  "rel_trans_postalcode_name" : "",
  "rel_trans_community_id": 0,
  "rel_trans_community_name" : "",
  "rel_trans_phone":"",
  "rel_trans_email":"",
  "rel_trans_nima":"",
  "rel_trans_cnae":"",
  "rel_trans_inscription":"",
  "rel_trans_opt":0,
  "rel_trans_licenseplate":"",
  "rel_trans_economicactivity":"",
  
  "formrespprodstore_id": 0,
  "resp_prod_store_id" : 0,
  "resp_prod_documnettype_id" : 1,
  "resp_prod_documentid" : "",
  "resp_prod_tradename" : "",
  "resp_prod_name" : "",
  "resp_prod_contactname" : "",
  "resp_prod_roadtype_id" : 74,
  "resp_prod_street" : "",
  "resp_prod_country_id": 1,
  "resp_prod_country_name":"",
  "resp_prod_province_id": 30,
  "resp_prod_province_name":"",
  "resp_prod_postalcode_id":6911,
  "resp_prod_postalcode_code":"",
  "resp_prod_postalcode_name":"",
  "resp_prod_community_id": 6,
  "resp_prod_community_name":"",
  "resp_prod_phone":"",
  "resp_prod_email":"",
  "resp_prod_nima":"",
  "resp_prod_cnae":"",
  "resp_prod_inscription":"",
  "resp_prod_opt":0,
  "resp_prod_licenseplate":"",
  "resp_prod_economicactivity":"",

  "opt_tras_shared":false,
  "ori_tras_shared":false,
  "aut_tras_shared":false,
  "dest_tras_shared":false,
  "aut_dest_shared":false,
  "rel_trans_shared":false,
  "resp_prod_shared":false,

  "sendbyemail_form_opt_tras":false,
  "sendbyemail_form_ori_tras":false,
  "sendbyemail_form_aut_tras":false,
  "sendbyemail_form_dest_tras":false,
  "sendbyemail_form_aut_dest":false,
  "sendbyemail_form_rel_trans":false,
  "sendbyemail_form_resp_prod":false,
 
};
  
const initialDocumentTypesToSelect = [{
  "id": "",
  "name": "",
   "entitycode":"F"
}];

const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialRDToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": ""
}];
 
 
const useStyles = makeStyles((theme) => ({
  root: {
    width: '1020px',
  },
  backcolor: {
    backgroundColor:  "#F4F4F4"
  },
  heading: {
    fontSize: 14,
    paddingLeft: 6,
    width: '220px',
    color: "#067330"
  },
  secondaryHeading: {
    fontSize: 14,
    width: '740px',
    color: "#000000",
  },
  thirdHeading: {
    fontSize: 14,
    width: '740px',
    color: "#e74a3b",
  },
}));

export const NTEditOrCreate = ({id, showModalNTSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi);   
  
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
  const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
  const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
  const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
  const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
  const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 

  const opt_tras_view = useSelector((state) => state.formatDIUser.opt_tras_view); 
  const opt_tras_expand = useSelector((state) => state.formatDIUser.opt_tras_expand);
  const ori_tras_view = useSelector((state) => state.formatDIUser.ori_tras_view); 
  const ori_tras_expand = useSelector((state) => state.formatDIUser.ori_tras_expand);
  const aut_tras_view = useSelector((state) => state.formatDIUser.aut_tras_view); 
  const aut_tras_expand = useSelector((state) => state.formatDIUser.aut_tras_expand);
  const dest_tras_view = useSelector((state) => state.formatDIUser.dest_tras_view); 
  const dest_tras_expand = useSelector((state) => state.formatDIUser.dest_tras_expand);
  const aut_dest_view = useSelector((state) => state.formatDIUser.aut_dest_view); 
  const aut_dest_expand = useSelector((state) => state.formatDIUser.aut_dest_expand);
  const rel_trans_view = useSelector((state) => state.formatDIUser.rel_trans_view); 
  const rel_trans_expand = useSelector((state) => state.formatDIUser.rel_trans_expand);
  const resp_prod_view = useSelector((state) => state.formatDIUser.resp_prod_view); 
  const resp_prod_expand = useSelector((state) => state.formatDIUser.resp_prod_expand);
  const code_description_view = useSelector((state) => state.formatDIUser.code_description_view);
  const code_treatmenttype_origin_view = useSelector((state) => state.formatDIUser.code_treatmenttype_origin_view);
  const code_treatmenttype_destine_view = useSelector((state) => state.formatDIUser.code_treatmenttype_destine_view);
  const code_processtype_origin_view = useSelector((state) => state.formatDIUser.code_processtype_origin_view);
  const code_processtype_destine_view = useSelector((state) => state.formatDIUser.code_processtype_destine_view);
  const code_dangerousness_view = useSelector((state) => state.formatDIUser.code_dangerousness_view); 
  const code_description_handle = useSelector((state) => state.formatDIUser.code_description_handle);
  const code_treatmenttype_origin_handle = useSelector((state) => state.formatDIUser.code_treatmenttype_origin_handle);
  const code_treatmenttype_destine_handle = useSelector((state) => state.formatDIUser.code_treatmenttype_destine_handle);
  const code_processtype_origin_handle = useSelector((state) => state.formatDIUser.code_processtype_origin_handle);
  const code_processtype_destine_handle = useSelector((state) => state.formatDIUser.code_processtype_destine_handle);
  const code_dangerousness_handle = useSelector((state) => state.formatDIUser.code_dangerousness_handle);
  const charac_danger_handle = useSelector((state) => state.formatDIUser.charac_danger_handle);
  const [formNT, setFormNT] = useState(initialStateNT);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  const [hasbeenshared, setHasbeenshared] = useState(false);
  const [foundNumberOfDI, setFoundNumberOfDI ]= useState(false);
  const [documentTypesToSelect,setDocumentTypesToSelect]= useState(initialDocumentTypesToSelect); 
  const [roadTypesToSelect,setRoadTypesToSelect]= useState(initialRDToSelect);
  const [optTypeToSelect,setOptTypeToSelect]= useState(initialRDToSelect);
  const [communityToSelect,setCommunityToSelect]= useState(initialRDToSelect); 
  const [treatmenttypeToSelect,setTreatmenttypeToSelect]= useState(initialRDToSelect);
  const [processtypeToSelect,setProcesstypeToSelect]= useState(initialRDToSelect);
  const [dangerousness,setDangerousness]= useState(initialRDToSelect); 
  const [expanded, setExpanded] =  useState(false);
  const [showModalSearchCodeLERS, setShowModalSearchCodeLERS] =  useState(false);
  const [showModalSearchDescriptions, setShowModalSearchDescriptions] =  useState(false);  

  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalNTSettings) {
        setFormNT(initialStateNT);
        setFormNT(formNT => ({
          ...formNT
        })); 
        setIsLoadingErrorData(false);
        setErrorsForm({});
        setDocumentTypesToSelect(initialDocumentTypesToSelect);
        setRoadTypesToSelect(initialRDToSelect);
        setCommunityToSelect(initialRDToSelect); 
        setOptTypeToSelect(initialRDToSelect);
        setTreatmenttypeToSelect(initialRDToSelect);
        setProcesstypeToSelect(initialRDToSelect);
        setDangerousness(initialTypesToSelect);
        setExpanded(false); 
        setShowModalSearchCodeLERS(false);
        setShowModalSearchDescriptions(false);
        setHasbeenshared(false);
        setFoundNumberOfDI(false);
        dispatch(setLoading(false));
        navigate(typeOfList==="1"?"/nt":"/home"); 
        return () => {};
      }
    },
    [
      setFormNT, 
      setIsLoadingErrorData,
      setErrorsForm,
      setDocumentTypesToSelect,
      setRoadTypesToSelect,
      setCommunityToSelect, 
      setOptTypeToSelect,
      setTreatmenttypeToSelect,
      setProcesstypeToSelect,
      setDangerousness,
      setExpanded,
      setShowModalSearchCodeLERS,
      setShowModalSearchDescriptions,   
      setHasbeenshared, 
      setFoundNumberOfDI,
      showModalNTSettings,
      navigate,  
      typeOfList,
      dispatch]
  );
  
  const handleCloseDataEditForm = () => {
    
    setFormNT(initialStateNT);
    setFormNT(formNT => ({
      ...formNT 
    })); 
    setIsLoadingErrorData(false);
    setErrorsForm({});
    setDocumentTypesToSelect(initialDocumentTypesToSelect);
    setRoadTypesToSelect(initialRDToSelect);
    setCommunityToSelect(initialRDToSelect); 
    setOptTypeToSelect(initialRDToSelect);
    setTreatmenttypeToSelect(initialRDToSelect);
    setProcesstypeToSelect(initialRDToSelect);
    setDangerousness(initialTypesToSelect);
    setExpanded(false);
    setHasbeenshared(false);
    setShowModalSearchCodeLERS(false);
    setShowModalSearchDescriptions(false);    
    setFoundNumberOfDI(false);
    dispatch(setLoading(false));
    navigate(typeOfList==="1"?"/nt":"/home"); 
    return () => {};
	};
        
  const handleChangeDataEditFormAmount = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" kg","")):0;
    setFormNT(formNT => ({
      ...formNT,
      [name]: newValue,
    }));
  };

  const handleBlurDataEditFormAmount = (e) => {
    handleChangeDataEditFormAmount(e);
    setErrorsForm(validateformNT());
  };
    
  const handleChangeDataEditForm = (e) => {
    const { name, value } = e.target;
    setFormNT(formNT => ({
      ...formNT,
      [name]: value,
    }));
  };

  const handleBlurDataEditForm = (e) => {
    handleChangeDataEditForm(e);
    setErrorsForm(validateformNT());
  };

  const handleChangeSelectDate = (event) => {
    const selectedDate = event ? new Date(event) : null;

    // Calcular end_date_nt sumando 3 años
    const endDate = selectedDate ? new Date(selectedDate) : null;
    if (endDate) {
      endDate.setFullYear(endDate.getFullYear() + 3);
    }

    setFormNT(prev => ({
      ...prev,
      init_date_nt: selectedDate,
      end_date_nt: endDate,
    }));
  };


  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsForm(validateformNT());
  };

  const handleChangeSelectEndDate = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      end_date_nt: event!==null?new Date(event):null
    }));
  };

  const handleChangeEEmergency = (e) => { 
    setFormNT(formNT => ({
      ...formNT,
      isemergency: !formNT.isemergency
    }));
  }; 

    const handleChangeEnabledDefaultOptions = (e) => { 
    setFormNT(formNT => ({
      ...formNT,
      isindividual: !formNT.isindividual,
      ismultiple: formNT.isindividual
    }));
  }; 


  const handleBlurSelectEndDate = (e) => {
    handleChangeSelectEndDate(e);
    setErrorsForm(validateformNT());
  };

  const deleteDataCodeLer = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      codeler_id:0,
      codeler_code: "",
      codeler_namees:"",
      codeler_nameen: ""
    }));
  };

  const searchFormCodeLer = (event) => {
    setShowModalSearchCodeLERS(true);
  };

  const deleteDataDescription = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      description_id:0,
      description_code: "",
      description_namees:"",
      description_nameen: ""
    }));
  };

  const searchFormDescription = (event) => {
    setShowModalSearchDescriptions(true);
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };

  const handleChangeSelectTreatmentTypeOrigin = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      treatmenttypeorigin_id:event.target.value
    }));
  };

  const handleBlurSelectTreatmentTypeOrigin = (e) => {
    handleChangeSelectTreatmentTypeOrigin(e);
  };

  const handleChangeSelectTreatmentTypeDestine = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      treatmenttypedestine_id:event.target.value

    }));
  };

  const handleBlurSelectTreatmentTypeDestine = (e) => {
    handleChangeSelectTreatmentTypeDestine(e);
  };

  const handleChangeSelectProcessTypeOrigin = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      processtypepeorigin_id:event.target.value
    }));
  };

  const handleBlurSelectProcessTypeOrigin = (e) => {
    handleChangeSelectProcessTypeOrigin(e);
  };

  const handleChangeSelectProcessTypeDestine = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      processtypedestine_id:event.target.value
    }));
  };

  const handleBlurSelectProcessTypeDestine = (e) => {
    handleChangeSelectProcessTypeDestine(e);
  };

  const handleChangeSelectDangerousness = (event) => {
    setFormNT(formNT => ({
      ...formNT,
      dangerousness_id:event.target.value
    }));
  };

  const handleBlurSelectDangerousness = (e) => {
    handleChangeSelectDangerousness(e);
  };

  const validateformNT = () => {
    let errorsForm = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
       
    if (foundNumberOfDI){
      errorsForm.number_nt='Text_FieldnumberdiExist';
    }  else{
      if (regexInvalidCharacters.test(formNT.number_nt)) {
        errorsForm.number_nt = 'Text_TextNoValid';
      } 
    }
    
    if (regexInvalidCharacters.test(formNT.frecuency)) {
      errorsForm.frecuency = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.number_nt_refused)) {
      errorsForm.number_nt_refused = 'Text_TextNoValid';
    } 
     if (regexInvalidCharacters.test(formNT.reason_emergency)) {
      errorsForm.reason_emergency = 'Text_TextNoValid';
    }  
    if (regexInvalidCharacters.test(formNT.opt_tras_documentid)) {
      errorsForm.opt_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_tradename)) {
      errorsForm.opt_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_name)) {
      errorsForm.opt_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_contactname)) {
      errorsForm.opt_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_street)) {
      errorsForm.opt_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_postalcode_code)) {
      errorsForm.opt_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.opt_tras_documentid!=="" && formNT.opt_tras_street!==""){
        if (formNT.opt_tras_postalcode_code===undefined || formNT.opt_tras_postalcode_code===null || formNT.opt_tras_postalcode_code===""){
          errorsForm.opt_tras_postalcode_code='Text_Field_POSTALCODE_Opt_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_postalcode_code)) {
      errorsForm.ori_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.ori_tras_documentid!=="" && formNT.ori_tras_street!==""){
        if (formNT.ori_tras_postalcode_code===undefined || formNT.ori_tras_postalcode_code===null || formNT.ori_tras_postalcode_code===""){
          errorsForm.ori_tras_postalcode_code='Text_Field_POSTALCODE_Ori_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_postalcode_code)) {
      errorsForm.aut_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.aut_tras_documentid!=="" && formNT.aut_tras_street!==""){
        if (formNT.aut_tras_postalcode_code===undefined || formNT.aut_tras_postalcode_code===null || formNT.aut_tras_postalcode_code===""){
          errorsForm.aut_tras_postalcode_code='Text_Field_POSTALCODE_Aut_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_postalcode_code)) {
      errorsForm.dest_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.dest_tras_documentid!=="" && formNT.dest_tras_street!==""){
        if (formNT.dest_tras_postalcode_code===undefined || formNT.dest_tras_postalcode_code===null || formNT.dest_tras_postalcode_code===""){
          errorsForm.dest_tras_postalcode_code='Text_Field_POSTALCODE_Dest_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_postalcode_code)) {
      errorsForm.aut_dest_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.aut_dest_documentid!=="" && formNT.aut_dest_street!==""){
        if (formNT.aut_dest_postalcode_code===undefined || formNT.aut_dest_postalcode_code===null || formNT.aut_dest_postalcode_code===""){
          errorsForm.aut_dest_postalcode_code='Text_Field_POSTALCODE_Aut_Dest_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_postalcode_code)) {
      errorsForm.rel_trans_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.rel_trans_documentid!=="" && formNT.rel_trans_street!==""){
        if (formNT.rel_trans_postalcode_code===undefined || formNT.rel_trans_postalcode_code===null || formNT.rel_trans_postalcode_code===""){
          errorsForm.rel_trans_postalcode_code='Text_Field_POSTALCODE_Rel_Trans_Required';
        }
      }
    }
   if (regexInvalidCharacters.test(formNT.resp_prod_postalcode_code)) {
      errorsForm.resp_prod_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formNT.resp_prod_documentid!=="" && formNT.resp_prod_street!==""){
        if (formNT.resp_prod_postalcode_code===undefined || formNT.resp_prod_postalcode_code===null || formNT.resp_prod_postalcode_code===""){
          errorsForm.resp_prod_postalcode_code='Text_Field_POSTALCODE_Resp_Prod_Required';
        }
      }
    } 
    if (regexInvalidCharacters.test(formNT.opt_tras_phone)) {
      errorsForm.opt_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_email)) {
      errorsForm.opt_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.opt_tras_nima)) {
      errorsForm.opt_tras_nima = 'Text_TextNoValid';
    } else{
      if (formNT.opt_tras_nima===undefined || formNT.opt_tras_nima===null || formNT.opt_tras_nima===""){
        errorsForm.opt_tras_nima='Text_Field_NIMA_Opt_Tras_Required';
      }
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_cnae)) {
      errorsForm.opt_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_inscription)) {
      errorsForm.opt_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.opt_tras_licenseplate)) {
      errorsForm.opt_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.opt_tras_economicactivity)) {
      errorsForm.opt_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_documentid)) {
      errorsForm.ori_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_tradename)) {
      errorsForm.ori_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_name)) {
      errorsForm.ori_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_contactname)) {
      errorsForm.ori_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_street)) {
      errorsForm.ori_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_phone)) {
      errorsForm.ori_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_email)) {
      errorsForm.ori_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.ori_tras_nima)) {
      errorsForm.ori_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_cnae)) {
      errorsForm.ori_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_inscription)) {
      errorsForm.ori_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.ori_tras_licenseplate)) {
      errorsForm.ori_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.ori_tras_economicactivity)) {
      errorsForm.ori_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_documentid)) {
      errorsForm.aut_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_tradename)) {
      errorsForm.aut_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_name)) {
      errorsForm.aut_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_contactname)) {
      errorsForm.aut_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_street)) {
      errorsForm.aut_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_phone)) {
      errorsForm.aut_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_email)) {
      errorsForm.aut_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.aut_tras_nima)) {
      errorsForm.aut_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_cnae)) {
      errorsForm.aut_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_inscription)) {
      errorsForm.aut_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.aut_tras_licenseplate)) {
      errorsForm.aut_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_tras_economicactivity)) {
      errorsForm.aut_tras_economicactivity = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.dest_tras_documentid)) {
      errorsForm.dest_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_tradename)) {
      errorsForm.dest_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_name)) {
      errorsForm.dest_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_contactname)) {
      errorsForm.dest_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_street)) {
      errorsForm.dest_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_phone)) {
      errorsForm.dest_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_email)) {
      errorsForm.dest_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.dest_tras_nima)) {
      errorsForm.dest_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_cnae)) {
      errorsForm.dest_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_inscription)) {
      errorsForm.dest_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.dest_tras_licenseplate)) {
      errorsForm.dest_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.dest_tras_economicactivity)) {
      errorsForm.dest_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_documentid)) {
      errorsForm.aut_dest_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_tradename)) {
      errorsForm.aut_dest_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_name)) {
      errorsForm.aut_dest_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_contactname)) {
      errorsForm.aut_dest_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_street)) {
      errorsForm.aut_dest_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_phone)) {
      errorsForm.aut_dest_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_email)) {
      errorsForm.aut_dest_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.aut_dest_nima)) {
      errorsForm.aut_dest_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_cnae)) {
      errorsForm.aut_dest_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_inscription)) {
      errorsForm.aut_dest_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.aut_dest_licenseplate)) {
      errorsForm.aut_dest_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.aut_dest_economicactivity)) {
      errorsForm.aut_dest_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_documentid)) {
      errorsForm.rel_trans_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_tradename)) {
      errorsForm.rel_trans_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_name)) {
      errorsForm.rel_trans_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_contactname)) {
      errorsForm.rel_trans_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_street)) {
      errorsForm.rel_trans_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_phone)) {
      errorsForm.rel_trans_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_email)) {
      errorsForm.rel_trans_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.rel_trans_nima)) {
      errorsForm.rel_trans_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_cnae)) {
      errorsForm.rel_trans_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_inscription)) {
      errorsForm.rel_trans_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.rel_trans_licenseplate)) {
      errorsForm.rel_trans_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.rel_trans_economicactivity)) {
      errorsForm.rel_trans_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_documentid)) {
      errorsForm.resp_prod_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_tradename)) {
      errorsForm.resp_prod_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_name)) {
      errorsForm.resp_prod_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_contactname)) {
      errorsForm.resp_prod_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_street)) {
      errorsForm.resp_prod_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_phone)) {
      errorsForm.resp_prod_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_email)) {
      errorsForm.resp_prod_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formNT.resp_prod_nima)) {
      errorsForm.resp_prod_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_cnae)) {
      errorsForm.resp_prod_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_inscription)) {
      errorsForm.resp_prod_inscription = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_licenseplate)) {
      errorsForm.resp_prod_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.resp_prod_economicactivity)) {
      errorsForm.resp_prod_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.codeler_code)) {
      errorsForm.codeler_code = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.description_code)) {
      errorsForm.description_code = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.charac_danger)) {
      errorsForm.charac_danger = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.observations)) {
      errorsForm.observations = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.reason_refund)) {
      errorsForm.reason_refund = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formNT.action_refund)) {
      errorsForm.action_refund = 'Text_TextNoValid';
    }
     
    return errorsForm;
  };

  const handleConfirmFetchDataEditForm = (dataToSend) => {  
    const fetchData = async () => { 
      try {
        const getData = id !== "0"
          ? await helpHttp().put(ENDPOINT, `nt/updatent`, token, dataToSend)
          : await helpHttp().post(ENDPOINT, `nt/saveformnt`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    fetchData();
    handleCloseDataEditForm();
    return () => {};
  };
 
  const handleSubmitDataEditNT = () => {
    const errors = validateformNT();
    setErrorsForm(errors);
     if (Object.keys(errors).length === 0 && formNT.preiddoc_sheet !== '') {
      handleConfirmFetchDataEditForm(formNT); 
    } else {
      if (errors.preiddoc_sheet) {
          dispatch(warningErrorAction(t(errors.preiddoc_sheet)));
        } else if (errors.sufiddoc_sheet) {
          dispatch(warningErrorAction(t(errors.sufiddoc_sheet)));
        } else if (errors.number_nt) {
          dispatch(warningErrorAction(t(errors.number_nt)));
        } else if (errors.opt_tras_documentid) {
          dispatch(warningErrorAction(t(errors.opt_tras_documentid)));
        } else if (errors.opt_tras_tradename) {
          dispatch(warningErrorAction(t(errors.opt_tras_tradename)));
        } else if (errors.opt_tras_name) {
          dispatch(warningErrorAction(t(errors.opt_tras_name)));
        } else if (errors.opt_tras_contactname) {
          dispatch(warningErrorAction(t(errors.opt_tras_contactname)));
        } else if (errors.opt_tras_street) {
          dispatch(warningErrorAction(t(errors.opt_tras_street)));
        } else if (errors.opt_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.opt_tras_postalcode_code)));
        } else if (errors.opt_tras_phone) {
          dispatch(warningErrorAction(t(errors.opt_tras_phone)));
        } else if (errors.opt_tras_email) {
          dispatch(warningErrorAction(t(errors.opt_tras_email)));
        } else if (errors.opt_tras_nima) {
          dispatch(warningErrorAction(t(errors.opt_tras_nima)));
        } else if (errors.opt_tras_cnae) {
          dispatch(warningErrorAction(t(errors.opt_tras_cnae)));
        } else if (errors.opt_tras_inscription) {
          dispatch(warningErrorAction(t(errors.opt_tras_inscription)));
        } else if (errors.opt_tras_licenseplate) {
          dispatch(warningErrorAction(t(errors.opt_tras_licenseplate)));
        } else if (errors.opt_tras_economicactivity) {
          dispatch(warningErrorAction(t(errors.opt_tras_economicactivity)));
        } else if (errors.ori_tras_documentid) {
          dispatch(warningErrorAction(t(errors.ori_tras_documentid)));
        } else if (errors.ori_tras_tradename) {
          dispatch(warningErrorAction(t(errors.ori_tras_tradename)));
        } else if (errors.ori_tras_name) {
          dispatch(warningErrorAction(t(errors.ori_tras_name)));
        } else if (errors.ori_tras_contactname) {
          dispatch(warningErrorAction(t(errors.ori_tras_contactname)));
        } else if (errors.ori_tras_street) {
          dispatch(warningErrorAction(t(errors.ori_tras_street)));
        } else if (errors.ori_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.ori_tras_postalcode_code)));
        } else if (errors.ori_tras_phone) {
          dispatch(warningErrorAction(t(errors.ori_tras_phone)));
        } else if (errors.ori_tras_email) {
          dispatch(warningErrorAction(t(errors.ori_tras_email)));
        } else if (errors.ori_tras_nima) {
          dispatch(warningErrorAction(t(errors.ori_tras_nima)));
        } else if (errors.ori_tras_cnae) {
          dispatch(warningErrorAction(t(errors.ori_tras_cnae)));
        } else if (errors.ori_tras_inscription) {
          dispatch(warningErrorAction(t(errors.ori_tras_inscription)));
        } else if (errors.ori_tras_licenseplate) {
          dispatch(warningErrorAction(t(errors.ori_tras_licenseplate)));
        } else if (errors.ori_tras_economicactivity) {
          dispatch(warningErrorAction(t(errors.ori_tras_economicactivity)));
        } else if (errors.aut_tras_documentid) {
          dispatch(warningErrorAction(t(errors.aut_tras_documentid)));
        } else if (errors.aut_tras_tradename) {
          dispatch(warningErrorAction(t(errors.aut_tras_tradename)));
        } else if (errors.aut_tras_name) {
          dispatch(warningErrorAction(t(errors.aut_tras_name)));
        } else if (errors.aut_tras_contactname) {
          dispatch(warningErrorAction(t(errors.aut_tras_contactname)));
        } else if (errors.aut_tras_street) {
          dispatch(warningErrorAction(t(errors.aut_tras_street)));
        } else if (errors.aut_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.aut_tras_postalcode_code)));
        } else if (errors.aut_tras_phone) {
          dispatch(warningErrorAction(t(errors.aut_tras_phone)));
        } else if (errors.aut_tras_email) {
          dispatch(warningErrorAction(t(errors.aut_tras_email)));
        } else if (errors.aut_tras_nima) {
          dispatch(warningErrorAction(t(errors.aut_tras_nima)));
        } else if (errors.aut_tras_cnae) {
          dispatch(warningErrorAction(t(errors.aut_tras_cnae)));
        } else if (errors.aut_tras_inscription) {
          dispatch(warningErrorAction(t(errors.aut_tras_inscription)));
        } else if (errors.aut_tras_licenseplate) {
          dispatch(warningErrorAction(t(errors.aut_tras_licenseplate)));
        } else if (errors.aut_tras_economicactivity) {
          dispatch(warningErrorAction(t(errors.aut_tras_economicactivity)));
        } else if (errors.dest_tras_documentid) {
          dispatch(warningErrorAction(t(errors.dest_tras_documentid)));
        } else if (errors.dest_tras_tradename) {
          dispatch(warningErrorAction(t(errors.dest_tras_tradename)));
        } else if (errors.dest_tras_name) {
          dispatch(warningErrorAction(t(errors.dest_tras_name)));
        } else if (errors.dest_tras_contactname) {
          dispatch(warningErrorAction(t(errors.dest_tras_contactname)));
        } else if (errors.dest_tras_street) {
          dispatch(warningErrorAction(t(errors.dest_tras_street)));
        } else if (errors.dest_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.dest_tras_postalcode_code)));
        } else if (errors.dest_tras_phone) {
          dispatch(warningErrorAction(t(errors.dest_tras_phone)));
        } else if (errors.dest_tras_email) {
          dispatch(warningErrorAction(t(errors.dest_tras_email)));
        } else if (errors.dest_tras_nima) {
          dispatch(warningErrorAction(t(errors.dest_tras_nima)));
        } else if (errors.dest_tras_cnae) {
          dispatch(warningErrorAction(t(errors.dest_tras_cnae)));
        } else if (errors.dest_tras_inscription) {
          dispatch(warningErrorAction(t(errors.dest_tras_inscription)));
        } else if (errors.dest_tras_licenseplate) {
          dispatch(warningErrorAction(t(errors.dest_tras_licenseplate)));
        } else if (errors.dest_tras_economicactivity) {
          dispatch(warningErrorAction(t(errors.dest_tras_economicactivity)));
        } else if (errors.aut_dest_documentid) {
          dispatch(warningErrorAction(t(errors.aut_dest_documentid)));
        } else if (errors.aut_dest_tradename) {
          dispatch(warningErrorAction(t(errors.aut_dest_tradename)));
        } else if (errors.aut_dest_name) {
          dispatch(warningErrorAction(t(errors.aut_dest_name)));
        } else if (errors.aut_dest_contactname) {
          dispatch(warningErrorAction(t(errors.aut_dest_contactname)));
        } else if (errors.aut_dest_street) {
          dispatch(warningErrorAction(t(errors.aut_dest_street)));
        } else if (errors.aut_dest_postalcode_code) {
          dispatch(warningErrorAction(t(errors.aut_dest_postalcode_code)));
        } else if (errors.aut_dest_phone) {
          dispatch(warningErrorAction(t(errors.aut_dest_phone)));
        } else if (errors.aut_dest_email) {
          dispatch(warningErrorAction(t(errors.aut_dest_email)));
        } else if (errors.aut_dest_nima) {
          dispatch(warningErrorAction(t(errors.aut_dest_nima)));
        } else if (errors.aut_dest_cnae) {
          dispatch(warningErrorAction(t(errors.aut_dest_cnae)));
        } else if (errors.aut_dest_inscription) {
          dispatch(warningErrorAction(t(errors.aut_dest_inscription)));
        } else if (errors.aut_dest_licenseplate) {
          dispatch(warningErrorAction(t(errors.aut_dest_licenseplate)));
        } else if (errors.aut_dest_economicactivity) {
          dispatch(warningErrorAction(t(errors.aut_dest_economicactivity)));
        } else if (errors.rel_trans_documentid) {
          dispatch(warningErrorAction(t(errors.rel_trans_documentid)));
        } else if (errors.rel_trans_tradename) {
          dispatch(warningErrorAction(t(errors.rel_trans_tradename)));
        } else if (errors.rel_trans_name) {
          dispatch(warningErrorAction(t(errors.rel_trans_name)));
        } else if (errors.rel_trans_contactname) {
          dispatch(warningErrorAction(t(errors.rel_trans_contactname)));
        } else if (errors.rel_trans_street) {
          dispatch(warningErrorAction(t(errors.rel_trans_street)));
        } else if (errors.rel_trans_postalcode_code) {
          dispatch(warningErrorAction(t(errors.rel_trans_postalcode_code)));
        } else if (errors.rel_trans_phone) {
          dispatch(warningErrorAction(t(errors.rel_trans_phone)));
        } else if (errors.rel_trans_email) {
          dispatch(warningErrorAction(t(errors.rel_trans_email)));
        } else if (errors.rel_trans_nima) {
          dispatch(warningErrorAction(t(errors.rel_trans_nima)));
        } else if (errors.rel_trans_cnae) {
          dispatch(warningErrorAction(t(errors.rel_trans_cnae)));
        } else if (errors.rel_trans_inscription) {
          dispatch(warningErrorAction(t(errors.rel_trans_inscription)));
        } else if (errors.rel_trans_licenseplate) {
          dispatch(warningErrorAction(t(errors.rel_trans_licenseplate)));
        } else if (errors.rel_trans_economicactivity) {
          dispatch(warningErrorAction(t(errors.rel_trans_economicactivity)));
        } else if (errors.resp_prod_documentid) {
          dispatch(warningErrorAction(t(errors.resp_prod_documentid)));
        } else if (errors.resp_prod_tradename) {
          dispatch(warningErrorAction(t(errors.resp_prod_tradename)));
        } else if (errors.resp_prod_name) {
          dispatch(warningErrorAction(t(errors.resp_prod_name)));
        } else if (errors.resp_prod_contactname) {
          dispatch(warningErrorAction(t(errors.resp_prod_contactname)));
        } else if (errors.resp_prod_street) {
          dispatch(warningErrorAction(t(errors.resp_prod_street)));
        } else if (errors.resp_prod_postalcode_code) {
          dispatch(warningErrorAction(t(errors.resp_prod_postalcode_code)));
        } else if (errors.resp_prod_phone) {
          dispatch(warningErrorAction(t(errors.resp_prod_phone)));
        } else if (errors.resp_prod_email) {
          dispatch(warningErrorAction(t(errors.resp_prod_email)));
        } else if (errors.resp_prod_nima) {
          dispatch(warningErrorAction(t(errors.resp_prod_nima)));
        } else if (errors.resp_prod_cnae) {
          dispatch(warningErrorAction(t(errors.resp_prod_cnae)));
        } else if (errors.resp_prod_inscription) {
          dispatch(warningErrorAction(t(errors.resp_prod_inscription)));
        } else if (errors.resp_prod_licenseplate) {
          dispatch(warningErrorAction(t(errors.resp_prod_licenseplate)));
        } else if (errors.resp_prod_economicactivity) {
          dispatch(warningErrorAction(t(errors.resp_prod_economicactivity)));
        } else if (errors.codeler_code) {
          dispatch(warningErrorAction(t(errors.codeler_code)));
        } else if (errors.charac_danger) {
          dispatch(warningErrorAction(t(errors.charac_danger)));
        } else if (errors.reason_refund) {
          dispatch(warningErrorAction(t(errors.reason_refund)));
        } else if (errors.action_refund) {
          dispatch(warningErrorAction(t(errors.action_refund)));
        } else if (errors.observations) {
            dispatch(warningErrorAction(t(errors.observations)));
          } else if (errors.init_date_nt) {
            dispatch(warningErrorAction(t(errors.init_date_nt)));
        } else {
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }
    }
  }; 
   
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberNT = async () => {
        try {
          const getData = await helpHttp().get11(ENDPOINT,`nt/getExistNumberntbynt`,token,formNT.number_nt.replace(/[.\-/\\|]/g, "")) ;
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setFoundNumberOfDI(getData!==formNT.id && getData>0)       
          }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    }; 
    if (formNT.number_nt && formNT.number_nt.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberNT();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formNT.number_nt,formNT.id]);

  useEffect(() => {
     let isMounted = true;
     const fetchGetNumberNT = async () => {
         try {
           const getData = await helpHttp().get8(ENDPOINT,`nt/getlastnumbernt`,token,defaultStore.id,formNT.preiddoc_sheet) ;
           if (getData.err) {
             dispatch(warningErrorAction(t('Text_InvalidCredentials')));
           } else if (isMounted && getData>0) {
              setFormNT(formNT => ({
               ...formNT,
               sufiddoc_sheet: getData
             }));       
           }else{
              setFormNT(formNT => ({
                ...formNT,
                sufiddoc_sheet: Number(new Date().getFullYear())*10000000+1
              }));    

           }
         } catch (error) {
             dispatch(warningErrorAction(t('Text_IncorrectData'))); 
         }
     }; 
     if (formNT.preiddoc_sheet && (id===undefined  || id===null  || id==="" || id===0 || id==="0")){
       fetchGetNumberNT();
     } 
     return () => { isMounted = false };
   }, [t,token,dispatch,formNT.preiddoc_sheet,defaultStore.id,id]);
  

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;

    const fetchDataRoadType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setRoadTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataOptType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOptTypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCommunity = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynamees`, token)
        : await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCommunityToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDocumentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `documenttype/simpledocumenttypesbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDocumentTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataTreatmentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `treatmenttype/treatmenttypesorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTreatmenttypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataProcessType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `processtype/processtypesorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setProcesstypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDangerousness = async () => {
      try {
        const getData = i18n.language==='es' 
          ?await helpHttp().get(ENDPOINT, `dangerousness/dangerousnessorderbynamees`, token)
          :await helpHttp().get(ENDPOINT, `dangerousness/dangerousnessorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDangerousness(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (showModalNTSettings && formNT.id!==null){
      fetchDataDocumentType();
      fetchDataRoadType();
      fetchDataCommunity();
      fetchDataOptType();
      fetchDataTreatmentType();
      fetchDataProcessType();
      fetchDataDangerousness();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formNT.id,showModalNTSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistCodeLer = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`nt/getexistcodelerbycode/`,token,formNT.codeler_code.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!=="" && getData>0){
            fetchCodeLerCode();
          }else{
            setFormNT(formNT => ({
              ...formNT,
              codeler_id: 0,
              codeler_namees: "",
              codeler_nameen: "" 
            }));
            
          }
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchCodeLerCode = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`nt/getformcodelerfindbycode/`,token,formNT.codeler_code.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
           
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!==""){
            setFormNT(formNT => ({
                ...formNT,
                codeler_id: getData.id, 
                codeler_namees: getData.namees,
                codeler_nameen: getData.nameen    
              }));
        }  
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (showModalNTSettings ){
      if (formNT.codeler_code && formNT.codeler_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistCodeLer();
      } 
    }  
    return () => { isMounted = false };
}, [t,token,dispatch,formNT.codeler_code,setIsLoadingErrorData,setFormNT,showModalNTSettings]);

useEffect(() => {
  let isMounted = true;
  const fetchExistDescription = async () => {
    try {
      const getData = await helpHttp().get2(ENDPOINT,`nt/getexistdescriptionbycode/`,token,formNT.description_code.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        
      } else if (isMounted) {
        if (getData!==undefined && getData!==null && getData!=="" && getData>0){
          fetchDescriptionCode();
        }else{
          setFormNT(formNT => ({
            ...formNT,
            description_id: 0,
            description_namees: "",
            description_nameen: "" 
          }));
          
        }
      }  
    } catch (error) {
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }
  };
  const fetchDescriptionCode = async () => {
    try {
      const getData = await helpHttp().get2(ENDPOINT,`nt/getformdescriptionfindbycode/`,token,formNT.description_code.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        
      } else if (isMounted) {
        if (getData!==undefined && getData!==null && getData!==""){
          setFormNT(formNT => ({
            ...formNT,
            description_id: getData.id, 
            description_namees: getData.namees,
            description_nameen: getData.nameen
          }));
      }  
      }  
    } catch (error) {
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }
  };
  if (showModalNTSettings ){
    if (formNT.description_code && formNT.description_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
      fetchExistDescription();
    }  
  } 
  return () => { isMounted = false };
  }, [t,token,dispatch,formNT.description_code,setIsLoadingErrorData,setFormNT,showModalNTSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchDataForm = async () => { 
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`nt/getntbyid/`,token,id);
        if (getData.err) {
          setFormNT(initialStateNT); 
          dispatch(setLoading(false));
          setIsLoadingErrorData(true);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormNT(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    if (showModalNTSettings ){
      if (id!=="0"){
        if (formNT.id===""){
          dispatch(setLoading(true));
          fetchDataForm();
        }
      }else{
        setFormNT(initialStateNT);
        setFormNT(formNT => ({
          ...formNT,
          ownformnt_id:0,
          defaultStore_id:defaultStore.id,
          useraccount_id:useraccount_id,
          defaultformatnumber:defaulttypesdi.id,
          isFinished:true,
          isScanned:false,
          preiddoc_sheet:"NT00"+defaulttypesdi.default_opt_tras_nima,
          sufiddoc_sheet:defaulttypesdi.default_sufiddoc_sheet!==undefined && defaulttypesdi.default_sufiddoc_sheet!=="" && defaulttypesdi.default_sufiddoc_sheet!=="0" && defaulttypesdi.default_sufiddoc_sheet!==0?defaulttypesdi.default_sufiddoc_sheet:Number(new Date().getFullYear())*10000000+1,
          number_nt:defaulttypesdi.default_number_dt || "NT00"+(defaulttypesdi.default_opt_tras_nima?defaulttypesdi.default_opt_tras_nima:"")+(defaulttypesdi.default_sufiddoc_sheet?defaulttypesdi.default_sufiddoc_sheet:Number(new Date().getFullYear())*10000000+1),
          init_date_nt:new Date(),
          end_date_nt:"",
          isindividual:false,
          ismultiple:true,
          frecuency:"",
          number_nt_refused:"",
          isemergency:false,
          reason_emergency:"",

          formopttrasstore_id:0,
          opt_tras_store_id:defaulttypesdi.default_opt_tras_id || 0,
          opt_tras_documnettype_id:defaulttypesdi.default_opt_tras_documnettype_id!==0?defaulttypesdi.default_opt_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          opt_tras_documentid:defaulttypesdi.default_opt_tras_documentid || "",
          opt_tras_tradename:defaulttypesdi.default_opt_tras_tradename || "",
          opt_tras_name:defaulttypesdi.default_opt_tras_name || "",
          opt_tras_contactname:defaulttypesdi.default_opt_tras_contactname || "",
          opt_tras_roadtype_id:defaulttypesdi.default_opt_tras_roadtype_id!==0?defaulttypesdi.default_opt_tras_roadtype_id: Number(DEFAULTROADTYE),
          opt_tras_street:defaulttypesdi.default_opt_tras_street || "",
          opt_tras_country_id:defaulttypesdi.default_opt_tras_country_id!==0?defaulttypesdi.default_opt_tras_country_id:Number(DEFAULTCOUNTRY),
          opt_tras_country_name:defaulttypesdi.default_opt_tras_country_name!==""?defaulttypesdi.default_opt_tras_country_name:DEFAULTCOUNTRY_NAME,
          opt_tras_province_id:defaulttypesdi.default_opt_tras_province_id!==0?defaulttypesdi.default_opt_tras_province_id:Number(DEFAULTPROVINCE),
          opt_tras_province_name:defaulttypesdi.default_opt_tras_province_name!==""?defaulttypesdi.default_opt_tras_province_name:DEFAULTPROVINCE_NAME,
          opt_tras_postalcode_id:defaulttypesdi.default_opt_tras_postalcode_id!==0?defaulttypesdi.default_opt_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          opt_tras_postalcode_code:defaulttypesdi.default_opt_tras_postalcode_code!==""?defaulttypesdi.default_opt_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
          opt_tras_postalcode_name:defaulttypesdi.default_opt_tras_postalcode_name!==""?defaulttypesdi.default_opt_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
          opt_tras_community_id:defaulttypesdi.default_opt_tras_community_id!==0?defaulttypesdi.default_opt_tras_community_id:Number(DEFAULTCOMMUNITY),
          opt_tras_community_name:defaulttypesdi.default_opt_tras_community_name!==""?defaulttypesdi.default_opt_tras_community_id:DEFAULTCOMMUNITY_NAME,
          opt_tras_phone:defaulttypesdi.default_opt_tras_phone || "",
          opt_tras_email:defaulttypesdi.default_opt_tras_email || "",
          opt_tras_nima:defaulttypesdi.default_opt_tras_nima || "",
          opt_tras_cnae:defaulttypesdi.default_opt_tras_cnae || "",
          opt_tras_inscription:defaulttypesdi.default_opt_tras_inscription || 0,
          opt_tras_opt:defaulttypesdi.default_opt_tras_opt || 0,
          opt_tras_licenseplate:defaulttypesdi.default_opt_tras_licenseplate || "",
          opt_tras_economicactivity:defaulttypesdi.default_opt_tras_economicactivit || "",
          
          formoritrasstore_id:0,
          ori_tras_store_id:defaulttypesdi.default_ori_tras_id || 0,
          ori_tras_documnettype_id:defaulttypesdi.default_ori_tras_documnettype_id!==0?defaulttypesdi.default_ori_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          ori_tras_documentid:defaulttypesdi.default_ori_tras_documentid || "",
          ori_tras_tradename:defaulttypesdi.default_ori_tras_tradename || "",
          ori_tras_name:defaulttypesdi.default_ori_tras_name || "",
          ori_tras_contactname:defaulttypesdi.default_ori_tras_contactname || "",
          ori_tras_roadtype_id:defaulttypesdi.default_ori_tras_roadtype_id!==0?defaulttypesdi.default_ori_tras_roadtype_id: Number(DEFAULTROADTYE),
          ori_tras_street:defaulttypesdi.default_ori_tras_street || "",
          ori_tras_country_id:defaulttypesdi.default_ori_tras_country_id!==0?defaulttypesdi.default_ori_tras_country_id:Number(DEFAULTCOUNTRY),
          ori_tras_country_name:defaulttypesdi.default_ori_tras_country_name!==""?defaulttypesdi.default_ori_tras_country_name:DEFAULTCOUNTRY_NAME,
          ori_tras_province_id:defaulttypesdi.default_ori_tras_province_id!==0?defaulttypesdi.default_ori_tras_province_id:Number(DEFAULTPROVINCE),
          ori_tras_province_name:defaulttypesdi.default_ori_tras_province_name!==""?defaulttypesdi.default_ori_tras_province_name:DEFAULTPROVINCE_NAME,
          ori_tras_postalcode_id:defaulttypesdi.default_ori_tras_postalcode_id!==0?defaulttypesdi.default_ori_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          ori_tras_postalcode_code:defaulttypesdi.default_ori_tras_postalcode_code!==""?defaulttypesdi.default_ori_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
          ori_tras_postalcode_name:defaulttypesdi.default_ori_tras_postalcode_name!==""?defaulttypesdi.default_ori_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
          ori_tras_community_id:defaulttypesdi.default_ori_tras_community_id!==0?defaulttypesdi.default_ori_tras_community_id:Number(DEFAULTCOMMUNITY),
          ori_tras_community_name:defaulttypesdi.default_ori_tras_community_name!==""?defaulttypesdi.default_ori_tras_community_id:DEFAULTCOMMUNITY_NAME,
          ori_tras_phone:defaulttypesdi.default_ori_tras_phone || "",
          ori_tras_email:defaulttypesdi.default_ori_tras_email || "",
          ori_tras_nima:defaulttypesdi.default_ori_tras_nima || "",
          ori_tras_cnae:defaulttypesdi.default_ori_tras_cnae || "",
          ori_tras_inscription:defaulttypesdi.default_ori_tras_inscription || "",
          ori_tras_opt:defaulttypesdi.default_ori_tras_opt || 0,
          ori_tras_licenseplate:defaulttypesdi.default_ori_tras_licenseplate || "",
          ori_tras_economicactivity:defaulttypesdi.default_ori_tras_economicactivity || "",

          aut_tras_store_id:defaulttypesdi.default_aut_tras_id || 0,
          aut_tras_documnettype_id:defaulttypesdi.default_aut_tras_documnettype_id!==0?defaulttypesdi.default_aut_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          aut_tras_documentid:defaulttypesdi.default_aut_tras_documentid || "",
          aut_tras_tradename:defaulttypesdi.default_aut_tras_tradename || "",
          aut_tras_name:defaulttypesdi.default_aut_tras_name || "",
          aut_tras_contactname:defaulttypesdi.default_aut_tras_contactname || "",
          aut_tras_roadtype_id:defaulttypesdi.default_aut_tras_roadtype_id!==0?defaulttypesdi.default_aut_tras_roadtype_id: Number(DEFAULTROADTYE),
          aut_tras_street:defaulttypesdi.default_aut_tras_street || "",
          aut_tras_country_id:defaulttypesdi.default_aut_tras_country_id!==0?defaulttypesdi.default_aut_tras_country_id:Number(DEFAULTCOUNTRY),
          aut_tras_country_name:defaulttypesdi.default_aut_tras_country_name!==""?defaulttypesdi.default_aut_tras_country_name:DEFAULTCOUNTRY_NAME,
          aut_tras_province_id:defaulttypesdi.default_aut_tras_province_id!==0?defaulttypesdi.default_aut_tras_province_id:Number(DEFAULTPROVINCE),
          aut_tras_province_name:defaulttypesdi.default_aut_tras_province_name!==""?defaulttypesdi.default_aut_tras_province_name:DEFAULTPROVINCE_NAME,
          aut_tras_postalcode_id:defaulttypesdi.default_aut_tras_postalcode_id!==0?defaulttypesdi.default_aut_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          aut_tras_postalcode_code:defaulttypesdi.default_aut_tras_postalcode_code!==""?defaulttypesdi.default_aut_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
          aut_tras_postalcode_name:defaulttypesdi.default_aut_tras_postalcode_name!==""?defaulttypesdi.default_aut_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
          aut_tras_community_id:defaulttypesdi.default_aut_tras_community_id!==0?defaulttypesdi.default_aut_tras_community_id:Number(DEFAULTCOMMUNITY),
          aut_tras_community_name:defaulttypesdi.default_aut_tras_community_name!==""?defaulttypesdi.default_aut_tras_community_id:DEFAULTCOMMUNITY_NAME,
          aut_tras_phone:defaulttypesdi.default_aut_tras_phone || "",
          aut_tras_email:defaulttypesdi.default_aut_tras_email || "",
          aut_tras_nima:defaulttypesdi.default_aut_tras_nima || "",
          aut_tras_cnae:defaulttypesdi.default_aut_tras_cnae || "",
          aut_tras_inscription:defaulttypesdi.default_aut_tras_inscription || "",
          aut_tras_opt:defaulttypesdi.default_aut_tras_opt || 0,
          aut_tras_licenseplate:defaulttypesdi.default_aut_tras_licenseplate || "",
          aut_tras_economicactivity:defaulttypesdi.default_aut_tras_economicactivity || "",

          formdesttrasstore_id:0,
          dest_tras_store_id:defaulttypesdi.default_dest_tras_id || 0,
          dest_tras_documnettype_id:defaulttypesdi.default_dest_tras_documnettype_id!==0?defaulttypesdi.default_dest_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          dest_tras_documentid:defaulttypesdi.default_dest_tras_documentid || "",
          dest_tras_tradename:defaulttypesdi.default_dest_tras_tradename || "",
          dest_tras_name:defaulttypesdi.default_dest_tras_name || "",
          dest_tras_contactname:defaulttypesdi.default_dest_tras_contactname || "",
          dest_tras_roadtype_id:defaulttypesdi.default_dest_tras_roadtype_id!==0?defaulttypesdi.default_dest_tras_roadtype_id: Number(DEFAULTROADTYE),
          dest_tras_street:defaulttypesdi.default_dest_tras_street || "",
          dest_tras_country_id:defaulttypesdi.default_dest_tras_country_id!==0?defaulttypesdi.default_dest_tras_country_id:Number(DEFAULTCOUNTRY),
          dest_tras_country_name:defaulttypesdi.default_dest_tras_country_name!==""?defaulttypesdi.default_dest_tras_country_name:DEFAULTCOUNTRY_NAME,
          dest_tras_province_id:defaulttypesdi.default_dest_tras_province_id!==0?defaulttypesdi.default_dest_tras_province_id:Number(DEFAULTPROVINCE),
          dest_tras_province_name:defaulttypesdi.default_dest_tras_province_name!==""?defaulttypesdi.default_dest_tras_province_name:DEFAULTPROVINCE_NAME,
          dest_tras_postalcode_id:defaulttypesdi.default_dest_tras_postalcode_id!==0?defaulttypesdi.default_dest_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          dest_tras_postalcode_code:defaulttypesdi.default_dest_tras_postalcode_code!==""?defaulttypesdi.default_dest_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
          dest_tras_postalcode_name:defaulttypesdi.default_dest_tras_postalcode_name!==""?defaulttypesdi.default_dest_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
          dest_tras_community_id:defaulttypesdi.default_dest_tras_community_id!==0?defaulttypesdi.default_dest_tras_community_id:Number(DEFAULTCOMMUNITY),
          dest_tras_community_name:defaulttypesdi.default_dest_tras_community_name!==""?defaulttypesdi.default_dest_tras_community_id:DEFAULTCOMMUNITY_NAME,
          dest_tras_phone:defaulttypesdi.default_dest_tras_phone || "",
          dest_tras_email:defaulttypesdi.default_dest_tras_email || "",
          dest_tras_nima:defaulttypesdi.default_dest_tras_nima || "",
          dest_tras_cnae:defaulttypesdi.default_dest_tras_cnae || "",
          dest_tras_inscription:defaulttypesdi.default_dest_tras_inscription || "",
          dest_tras_opt:defaulttypesdi.default_dest_tras_opt || 0,
          dest_tras_licenseplate:defaulttypesdi.default_dest_tras_licenseplate || "",
          dest_tras_economicactivity:defaulttypesdi.default_dest_tras_economicactivity || "",

          aut_dest_store_id:defaulttypesdi.default_aut_dest_id || 0,
          aut_dest_documnettype_id:defaulttypesdi.default_aut_dest_documnettype_id!==0?defaulttypesdi.default_aut_dest_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          aut_dest_documentid:defaulttypesdi.default_aut_dest_documentid || "",
          aut_dest_tradename:defaulttypesdi.default_aut_dest_tradename || "",
          aut_dest_name:defaulttypesdi.default_aut_dest_name || "",
          aut_dest_contactname:defaulttypesdi.default_aut_dest_contactname || "",
          aut_dest_roadtype_id:defaulttypesdi.default_aut_dest_roadtype_id!==0?defaulttypesdi.default_aut_dest_roadtype_id: Number(DEFAULTROADTYE),
          aut_dest_street:defaulttypesdi.default_aut_dest_street || "",
          aut_dest_country_id:defaulttypesdi.default_aut_dest_country_id!==0?defaulttypesdi.default_aut_dest_country_id:Number(DEFAULTCOUNTRY),
          aut_dest_country_name:defaulttypesdi.default_aut_dest_country_name!==""?defaulttypesdi.default_aut_dest_country_name:DEFAULTCOUNTRY_NAME,
          aut_dest_province_id:defaulttypesdi.default_aut_dest_province_id!==0?defaulttypesdi.default_aut_dest_province_id:Number(DEFAULTPROVINCE),
          aut_dest_province_name:defaulttypesdi.default_aut_dest_province_name!==""?defaulttypesdi.default_aut_dest_province_name:DEFAULTPROVINCE_NAME,
          aut_dest_postalcode_id:defaulttypesdi.default_aut_dest_postalcode_id!==0?defaulttypesdi.default_aut_dest_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          aut_dest_postalcode_code:defaulttypesdi.default_aut_dest_postalcode_code!==""?defaulttypesdi.default_aut_dest_postalcode_code:DEFAULTPOSTALCODE_CODE,
          aut_dest_postalcode_name:defaulttypesdi.default_aut_dest_postalcode_name!==""?defaulttypesdi.default_aut_dest_postalcode_name:DEFAULTPOSTALCODE_NAME,
          aut_dest_community_id:defaulttypesdi.default_aut_dest_community_id!==0?defaulttypesdi.default_aut_dest_community_id:Number(DEFAULTCOMMUNITY),
          aut_dest_community_name:defaulttypesdi.default_aut_dest_community_name!==""?defaulttypesdi.default_aut_dest_community_id:DEFAULTCOMMUNITY_NAME,
          aut_dest_phone:defaulttypesdi.default_aut_dest_phone || "",
          aut_dest_email:defaulttypesdi.default_aut_dest_email || "",
          aut_dest_nima:defaulttypesdi.default_aut_dest_nima || "",
          aut_dest_cnae:defaulttypesdi.default_aut_dest_cnae || "",
          aut_dest_inscription:defaulttypesdi.default_aut_dest_inscription || "",
          aut_dest_opt:defaulttypesdi.default_aut_dest_opt || 0,
          aut_dest_licenseplate:defaulttypesdi.default_aut_dest_licenseplate || "",
          aut_dest_economicactivity:defaulttypesdi.default_aut_dest_economicactivity || "",

          codeler_id:defaulttypesdi.default_codeler_id || 0,
          codeler_code:defaulttypesdi.default_codeler_code || "",
          codeler_namees:defaulttypesdi.default_codeler_namees || "",
          codeler_nameen:defaulttypesdi.default_codeler_nameen || "",
          description_id:defaulttypesdi.default_description_id || 0,
          description_code:defaulttypesdi.default_description_code || "",
          description_namees:defaulttypesdi.default_description_namees || "",
          description_nameen:defaulttypesdi.default_description_nameen || "",

          treatmenttypeorigin_id:defaulttypesdi.default_treatmenttypeorigin_id || 0,
          treatmenttypeorigin_code:defaulttypesdi.default_treatmenttypeorigin_code || "",
          treatmenttypeorigin_namees:defaulttypesdi.default_treatmenttypeorigin_namees || "",
          treatmenttypeorigin_nameen:defaulttypesdi.default_treatmenttypeorigin_nameen || "",

          treatmenttypedestine_id:defaulttypesdi.default_treatmenttypedestine_id || 0,
          treatmenttypedestine_code:defaulttypesdi.default_treatmenttypedestine_code || "",
          treatmenttypedestine_namees:defaulttypesdi.default_treatmenttypedestine_namees || "",
          treatmenttypedestine_nameen:defaulttypesdi.default_treatmenttypedestine_nameen || "",

          processtypepeorigin_id:defaulttypesdi.default_processtypeorigin_id || 0,
          processtypepeorigin_code:defaulttypesdi.default_processtypeorigin_code || "",
          processtypepeorigin_namees:defaulttypesdi.default_processtypeorigin_namees || "",
          processtypepeorigin_nameen:defaulttypesdi.default_processtypeorigin_nameen || "",

          processtypedestine_id:defaulttypesdi.default_processtypedestine_id || 0,
          processtypedestine_code:defaulttypesdi.default_processtypedestine_code || "",
          processtypedestine_namees:defaulttypesdi.default_processtypedestine_namees || "",
          processtypedestine_nameen:defaulttypesdi.default_processtypedestine_nameen || "",

          dangerousness_id:defaulttypesdi.default_dangerousness_id || 0,
          dangerousness_namees:defaulttypesdi.default_dangerousness_namees || "",
          dangerousness_nameen:defaulttypesdi.default_dangerousness_nameen || "",

          formreltransstore_id:0,
          rel_trans_store_id:defaulttypesdi.default_rel_trans_id || 0,
          rel_trans_documnettype_id:defaulttypesdi.default_rel_trans_documnettype_id!==0?defaulttypesdi.default_rel_trans_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          rel_trans_documentid:defaulttypesdi.default_rel_trans_documentid || "",
          rel_trans_tradename:defaulttypesdi.default_rel_trans_tradename || "",
          rel_trans_name:defaulttypesdi.default_rel_trans_name || "",
          rel_trans_contactname:defaulttypesdi.default_rel_trans_contactname || "",
          rel_trans_roadtype_id:defaulttypesdi.default_rel_trans_roadtype_id!==0?defaulttypesdi.default_rel_trans_roadtype_id: Number(DEFAULTROADTYE),
          rel_trans_street:defaulttypesdi.default_rel_trans_street || "",
          rel_trans_country_id:defaulttypesdi.default_rel_trans_country_id!==0?defaulttypesdi.default_rel_trans_country_id:Number(DEFAULTCOUNTRY),
          rel_trans_country_name:defaulttypesdi.default_rel_trans_country_name!==""?defaulttypesdi.default_rel_trans_country_name:DEFAULTCOUNTRY_NAME,
          rel_trans_province_id:defaulttypesdi.default_rel_trans_province_id!==0?defaulttypesdi.default_rel_trans_province_id:Number(DEFAULTPROVINCE),
          rel_trans_province_name:defaulttypesdi.default_rel_trans_province_name!==""?defaulttypesdi.default_rel_trans_province_name:DEFAULTPROVINCE_NAME,
          rel_trans_postalcode_id:defaulttypesdi.default_rel_trans_postalcode_id!==0?defaulttypesdi.default_rel_trans_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          rel_trans_postalcode_code:defaulttypesdi.default_rel_trans_postalcode_code!==""?defaulttypesdi.default_rel_trans_postalcode_code:DEFAULTPOSTALCODE_CODE,
          rel_trans_postalcode_name:defaulttypesdi.default_rel_trans_postalcode_name!==""?defaulttypesdi.default_rel_trans_postalcode_name:DEFAULTPOSTALCODE_NAME,
          rel_trans_community_id:defaulttypesdi.default_rel_trans_community_id!==0?defaulttypesdi.default_rel_trans_community_id:Number(DEFAULTCOMMUNITY),
          rel_trans_community_name:defaulttypesdi.default_rel_trans_community_name!==""?defaulttypesdi.default_rel_trans_community_id:DEFAULTCOMMUNITY_NAME,
          rel_trans_phone:defaulttypesdi.default_rel_trans_phone || "",
          rel_trans_email:defaulttypesdi.default_rel_trans_email || "",
          rel_trans_nima:defaulttypesdi.default_rel_trans_nima || "",
          rel_trans_cnae:defaulttypesdi.default_rel_trans_cnae || "",
          rel_trans_inscription:defaulttypesdi.default_rel_trans_inscription || "",
          rel_trans_opt:defaulttypesdi.default_rel_trans_opt || 0,
          rel_trans_licenseplate:defaulttypesdi.default_rel_trans_licenseplate || "",
          rel_trans_economicactivity:defaulttypesdi.default_resp_prod_economicactivity || "",

          formrespprodstore_id:0,
          resp_prod_store_id:defaulttypesdi.default_resp_prod_id || 0,
          resp_prod_documnettype_id:defaulttypesdi.default_resp_prod_documnettype_id!==0?defaulttypesdi.default_resp_prod_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
          resp_prod_documentid:defaulttypesdi.default_resp_prod_documentid || "",
          resp_prod_tradename:defaulttypesdi.default_resp_prod_tradename || "",
          resp_prod_name:defaulttypesdi.default_resp_prod_name || "",
          resp_prod_contactname:defaulttypesdi.default_resp_prod_contactname || "",
          resp_prod_roadtype_id:defaulttypesdi.default_resp_prod_roadtype_id!==0?defaulttypesdi.default_resp_prod_roadtype_id: Number(DEFAULTROADTYE),
          resp_prod_street:defaulttypesdi.default_resp_prod_street || "",
          resp_prod_country_id:defaulttypesdi.default_resp_prod_country_id!==0?defaulttypesdi.default_resp_prod_country_id:Number(DEFAULTCOUNTRY),
          resp_prod_country_name:defaulttypesdi.default_resp_prod_country_name!==""?defaulttypesdi.default_resp_prod_country_name:DEFAULTCOUNTRY_NAME,
          resp_prod_province_id:defaulttypesdi.default_resp_prod_province_id!==0?defaulttypesdi.default_resp_prod_province_id:Number(DEFAULTPROVINCE),
          resp_prod_province_name:defaulttypesdi.default_resp_prod_province_name!==""?defaulttypesdi.default_resp_prod_province_name:DEFAULTPROVINCE_NAME,
          resp_prod_postalcode_id:defaulttypesdi.default_resp_prod_postalcode_id!==0?defaulttypesdi.default_resp_prod_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
          resp_prod_postalcode_code:defaulttypesdi.default_resp_prod_postalcode_code!==""?defaulttypesdi.default_resp_prod_postalcode_code:DEFAULTPOSTALCODE_CODE,
          resp_prod_postalcode_name:defaulttypesdi.default_resp_prod_postalcode_name!==""?defaulttypesdi.default_resp_prod_postalcode_name:DEFAULTPOSTALCODE_NAME,
          resp_prod_community_id:defaulttypesdi.default_resp_prod_community_id!==0?defaulttypesdi.default_resp_prod_community_id:Number(DEFAULTCOMMUNITY),
          resp_prod_community_name:defaulttypesdi.default_resp_prod_community_name!==""?defaulttypesdi.default_resp_prod_community_id:DEFAULTCOMMUNITY_NAME,
          resp_prod_phone:defaulttypesdi.default_resp_prod_phone || "",
          resp_prod_email:defaulttypesdi.default_resp_prod_email || "",
          resp_prod_nima:defaulttypesdi.default_resp_prod_nima || "",
          resp_prod_cnae:defaulttypesdi.default_resp_prod_cnae || "",
          resp_prod_inscription:defaulttypesdi.default_resp_prod_inscription || "",
          resp_prod_opt:defaulttypesdi.default_resp_prod_opt || "",
          resp_prod_licenseplate:defaulttypesdi.default_resp_prod_licenseplate || "",
          resp_prod_economicactivity:defaulttypesdi.default_resp_prod_economicactivity || "",

          opt_tras_shared:false,
          ori_tras_shared:false,
          aut_tras_shared:false,
          dest_tras_shared:false,
          aut_dest_shared:false,
          rel_trans_shared:false,
          resp_prod_shared:false,

          sendbyemail_form_opt_tras:false,
          sendbyemail_form_ori_tras:false,
          sendbyemail_form_aut_tras:false,
          sendbyemail_form_dest_tras:false,
          sendbyemail_form_aut_dest:false,
          sendbyemail_form_rel_trans:false,
          sendbyemail_form_resp_prod:false
        }));
        setHasbeenshared(false); 
      } 
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formNT.id,DEFAULTTYPEOFDOCUMENT,DEFAULTROADTYE, DEFAULTCOMMUNITY,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY,DEFAULTCOUNTRY_NAME,DEFAULTPROVINCE,DEFAULTPROVINCE_NAME,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_NAME,defaulttypesdi,defaultStore.id,useraccount_id,isLoadingData,showModalNTSettings]);  
 
    return (
        <>
          {showModalNTSettings ? ( 
            <div className="container-fluid formgeneral-send-wrapper">
              <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}> 
                <form onSubmit={handleCloseDataEditForm}>  
                  {/* HEADER */}
                  <div className="formgeneral-card-header">
                    <div className="formgeneral-header-content">
                      <div className="formgeneral-header-title2">
                        {isLoadingErrorData?
                          <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                          (isLoadingData?
                          <CircularProgress sx={{ color : "#f6c23e"}}/>:
                          <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                          &nbsp;&nbsp;{id==="0"?t('Text_NT_New'):t('Text_NT_Edit')+': '+formNT.number_nt}
                      </div>
                      <div className="email-card-actions">
                        {!isLoadingData && (
                          <>
                            <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditNT} >
                              {id==="0"?t('Button_Create'):t('Button_Update')}
                            </button>
                            <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditForm} >
                              {t('Button_Cancel')}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <br/>
  
                  {/* FORM CARD */}
                  {!isLoadingData ?
                    <>
                      <div className="formgeneral-card-form">
                        <div className="email-header-title3">{t('Text_NT_Line1')}</div>
                        <div className="email-header-title4">{t('Text_NT_Line2')}</div>
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <div className="row p-2">
                          <div className="form-group">  
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NT_SHEET').toUpperCase()} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="number_nt" 
                              name="number_nt"
                              value={formNT.number_nt}
                              inputProps={{ style: {width: i18n.language==='es'?400:400,  fontSize: '18px'}, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.number_nt!=null?t(errorsForm.number_nt):t('PlaceHolder_FORM_NT_SHEET')}
                              placeholder={t('PlaceHolder_FORM_NT_SHEET')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              /> 
                          </div> 
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_TYPE').toUpperCase()} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; 
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_INDIVIDUAL')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                            <Checkbox
                              id="isindividual" 
                              name="isindividual"
                              checked={formNT.isindividual}
                              onChange={handleChangeEnabledDefaultOptions}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, 
                              }}
                            /> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_MULTIPLE')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <Checkbox
                              id="ismultiple" 
                              name="ismultiple"
                              checked={formNT.ismultiple}
                              onChange={handleChangeEnabledDefaultOptions}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, 
                              }}
                            /> 
                          </div> 
                          <div className="form-group">   
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_INIT_DATE')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <DesktopDatePicker
                                id="init_date_nt" 
                                name="init_date_nt"
                                value={ formNT.init_date_nt!== null ? new Date(formNT.init_date_nt):null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                inputProps={{ style: {width: 190}, maxLength: 100 }}
                                label={errorsForm.init_date_nt!=null?t(errorsForm.init_date_nt):t('Text_NT_INIT_DATE')}
                                onBlur={handleBlurSelectDate}
                                onChange={handleChangeSelectDate}
                                disabled={hasbeenshared} 
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                    sx: {
                                      maxLength: i18n.language==='es'?192:201,
                                      width: i18n.language==='es'?192:201,
                                      fontSize: '18px',  
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_END_DATE')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <DesktopDatePicker
                                id="end_date_nt" 
                                name="end_date_nt"
                                value={ formNT.end_date_nt!== null ? new Date(formNT.end_date_nt):null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                inputProps={{ style: {width: 190}, maxLength: 100 }}
                                label={errorsForm.end_date_nt!=null?t(errorsForm.end_date_nt):t('Text_NT_END_DATE')}
                                onBlur={handleBlurSelectEndDate}
                                onChange={handleChangeSelectEndDate}
                                disabled={hasbeenshared} 
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                    sx: {
                                      maxLength: i18n.language==='es'?192:201,
                                      width: i18n.language==='es'?192:201,
                                      fontSize: '18px',  
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider> 
                          </div>
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_FRECUENCY')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="frecuency" 
                              name="frecuency"
                              value={formNT.frecuency}
                              inputProps={{ style: {width: i18n.language==='es'?611:630,  fontSize: '18px'}, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.frecuency!=null?t(errorsForm.frecuency):t('PlaceHolder_NT_FRECUENCY')}
                              placeholder={t('PlaceHolder_NT_FRECUENCY')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                            />  
                          </div> 
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_PREREFUND')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="number_nt_refused" 
                              name="number_nt_refused"
                              value={formNT.number_nt_refused}
                              inputProps={{ style: {width: i18n.language==='es'?607:742,  fontSize: '18px'}, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.number_nt_refused!=null?t(errorsForm.number_nt_refused):t('PlaceHolder_NT_PREREFUND')}
                              placeholder={t('PlaceHolder_NT_PREREFUND')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                            />  
                          </div> 
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_EMERGENCY')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <Checkbox
                              id="isemergency" 
                              name="isemergency"
                              checked={formNT.isemergency}
                              onChange={handleChangeEEmergency}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, 
                              }}
                            /> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_REASON')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="reason_emergency" 
                              name="reason_emergency"
                              value={formNT.reason_emergency}
                              inputProps={{ style: {width: i18n.language==='es'?513:574,  fontSize: '18px'}, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.reason_emergency!=null?t(errorsForm.reason_emergency):t('PlaceHolder_NT_REASON')}
                              placeholder={t('PlaceHolder_NT_REASON')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled={!formNT.isemergency}/>  
                          </div> 
                          {opt_tras_view && 
                            <Accordion className="accordionOptTras-root" expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1bh-content"
                                  id="panel1bh-header"
                                  disabled={!opt_tras_expand}
                                  className="accordionOptTras-backcolor"
                                >
                                  <Typography className="accordionOptTras-heading">{t('Text_FORM_OPT_TRAS')} :</Typography>
                                  <Typography className="accordionOptTras-secondaryHeading">
                                    {formNT.opt_tras_tradename!==undefined && formNT.opt_tras_tradename!==null && formNT.opt_tras_tradename!==""?formNT.opt_tras_tradename:t('Text_NOT_REPORTING')}
                                    {formNT.opt_tras_documentid!=="" && formNT.opt_tras_tradename===""?<span className={classes.thirdHeading}> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                    {formNT.opt_tras_documentid!=="" && formNT.opt_tras_street!=="" && !formNT.opt_tras_postalcode_id?<span className={classes.thirdHeading}> - {t('Text_Field_POSTALCODE_Opt_Tras_Required')} !!</span>:""}
                                    {formNT.opt_tras_documentid!=="" && formNT.opt_tras_nima==="" ?<span className={classes.thirdHeading}> - {t('Text_Field_NIMA_Opt_Tras_Required')} !!</span>:""}
                                    {errorsForm.opt_tras_email!==undefined && errorsForm.opt_tras_email!==""?<span className={classes.thirdHeading}>  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                    {(errorsForm.opt_tras_documentid!==undefined && errorsForm.opt_tras_documentid!=="") ||
                                    (errorsForm.opt_tras_tradename!==undefined && errorsForm.opt_tras_tradename!=="") ||
                                    (errorsForm.opt_tras_name!==undefined && errorsForm.opt_tras_name!=="") ||
                                    (errorsForm.opt_tras_contactname!==undefined && errorsForm.opt_tras_contactname!=="") ||
                                    (errorsForm.opt_tras_street!==undefined && errorsForm.opt_tras_street!=="") ||
                                    (errorsForm.opt_tras_phone!==undefined && errorsForm.opt_tras_phone!=="") ||
                                    (errorsForm.opt_tras_nima!==undefined && errorsForm.opt_tras_nima!=="") ||
                                    (errorsForm.opt_tras_cnae!==undefined && errorsForm.opt_tras_cnae!=="") ||
                                    (errorsForm.opt_tras_inscription!==undefined && errorsForm.opt_tras_inscription!=="") ||
                                    (errorsForm.opt_tras_opt!==undefined && errorsForm.opt_tras_opt!=="") ||
                                    (errorsForm.opt_tras_economicactivity!==undefined && errorsForm.opt_tras_economicactivity!=="") ||
                                    (errorsForm.opt_tras_licenseplate!==undefined && errorsForm.opt_tras_licenseplate!==""
                                    )
                                    ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <div className="accordion-inner-box">
                                    <NTCreateOrEditOptTras
                                      formNT={formNT}
                                      setFormNT={setFormNT}
                                      setIsLoadingErrorData={setIsLoadingErrorData}
                                      errorsForm={errorsForm}
                                      setErrorsForm={setErrorsForm}
                                      validateformNT={validateformNT}
                                      documentTypesToSelect={documentTypesToSelect}
                                      roadTypesToSelect={roadTypesToSelect}
                                      communityToSelect={communityToSelect} 
                                      expanded={expanded}
                                      optTypeToSelect={optTypeToSelect}
                                      hasbeenshared={hasbeenshared}
                                    />
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                          }
                          {ori_tras_view && 
                            <Accordion className="accordionOptTras-root" expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                                disabled={!ori_tras_expand}
                                className="accordionOptTras-backcolor"
                              >
                                <Typography className="accordionOptTras-heading">{t('Text_FORM_ORI_TRAS')} : <span>{t('Text_FORM_ORI_TRAS_PROD')}</span></Typography>
                                <Typography className="accordionOptTras-secondaryHeading">
                                  {formNT.ori_tras_tradename!==undefined && formNT.ori_tras_tradename!==null && formNT.ori_tras_tradename!==""?formNT.ori_tras_tradename:t('Text_NOT_REPORTING')}
                                  {formNT.ori_tras_documentid!=="" && formNT.ori_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                  {formNT.ori_tras_documentid!=="" && formNT.ori_tras_street!=="" && !formNT.ori_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Ori_Tras_Required')} !!</span>:""}
                                  {errorsForm.ori_tras_email!==undefined && errorsForm.ori_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                  {(errorsForm.ori_tras_documentid!==undefined && errorsForm.ori_tras_documentid!=="") ||
                                  (errorsForm.ori_tras_tradename!==undefined && errorsForm.ori_tras_tradename!=="") ||
                                  (errorsForm.ori_tras_name!==undefined && errorsForm.ori_tras_name!=="") ||
                                  (errorsForm.ori_tras_contactname!==undefined && errorsForm.ori_tras_contactname!=="") ||
                                  (errorsForm.ori_tras_street!==undefined && errorsForm.ori_tras_street!=="") ||
                                  (errorsForm.ori_tras_phone!==undefined && errorsForm.ori_tras_phone!=="") ||
                                  (errorsForm.ori_tras_nima!==undefined && errorsForm.ori_tras_nima!=="") ||
                                  (errorsForm.ori_tras_cnae!==undefined && errorsForm.ori_tras_cnae!=="") ||
                                  (errorsForm.ori_tras_inscription!==undefined && errorsForm.ori_tras_inscription!=="") ||
                                  (errorsForm.ori_tras_opt!==undefined && errorsForm.ori_tras_opt!=="") ||
                                  (errorsForm.ori_tras_economicactivity!==undefined && errorsForm.ori_tras_economicactivity!=="") ||
                                  (errorsForm.ori_tras_licenseplate!==undefined && errorsForm.ori_tras_licenseplate!=="")
                                  ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="accordion-inner-box">
                                  <NTCreateOrEditOriTras
                                    formNT={formNT}
                                    setFormNT={setFormNT}
                                    setIsLoadingErrorData={setIsLoadingErrorData}
                                    errorsForm={errorsForm}
                                    setErrorsForm={setErrorsForm}
                                    validateformNT={validateformNT}
                                    documentTypesToSelect={documentTypesToSelect}
                                    roadTypesToSelect={roadTypesToSelect}
                                    communityToSelect={communityToSelect} 
                                    expanded={expanded}
                                    optTypeToSelect={optTypeToSelect}
                                    hasbeenshared={hasbeenshared}
                                />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          } 
                          {aut_tras_view && 
                            <Accordion className="accordionOptTras-root" expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                                disabled={!aut_tras_expand}
                                className="accordionOptTras-backcolor"
                              >
                                <Typography className="accordionOptTras-heading">{t('Text_FORM_ORI_TRAS')} : <span>{t('Text_FORM_ORI_TRAS_EMPR')}</span></Typography>
                                <Typography className="accordionOptTras-secondaryHeading">
                                  {formNT.aut_tras_tradename!==undefined && formNT.aut_tras_tradename!==null && formNT.aut_tras_tradename!==""?formNT.aut_tras_tradename:t('Text_NOT_REPORTING')}
                                  {formNT.aut_tras_documentid!=="" && formNT.aut_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                  {formNT.aut_tras_documentid!=="" && formNT.aut_tras_street!=="" && !formNT.aut_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Tras_Required')} !!</span>:""}
                                  {errorsForm.aut_tras_email!==undefined && errorsForm.aut_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                  {(errorsForm.aut_tras_documentid!==undefined && errorsForm.aut_tras_documentid!=="") ||
                                  (errorsForm.aut_tras_tradename!==undefined && errorsForm.aut_tras_tradename!=="") ||
                                  (errorsForm.aut_tras_name!==undefined && errorsForm.aut_tras_name!=="") ||
                                  (errorsForm.aut_tras_contactname!==undefined && errorsForm.aut_tras_contactname!=="") ||
                                  (errorsForm.aut_tras_street!==undefined && errorsForm.aut_tras_street!=="") ||
                                  (errorsForm.aut_tras_phone!==undefined && errorsForm.aut_tras_phone!=="") ||
                                  (errorsForm.aut_tras_nima!==undefined && errorsForm.aut_tras_nima!=="") ||
                                  (errorsForm.aut_tras_cnae!==undefined && errorsForm.aut_tras_cnae!=="") ||
                                  (errorsForm.aut_tras_inscription!==undefined && errorsForm.aut_tras_inscription!=="") ||
                                  (errorsForm.aut_tras_opt!==undefined && errorsForm.aut_tras_opt!=="") ||
                                  (errorsForm.aut_tras_economicactivity!==undefined && errorsForm.aut_tras_economicactivity!=="") ||
                                  (errorsForm.aut_tras_licenseplate!==undefined && errorsForm.aut_tras_licenseplate!=="")
                                  ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="accordion-inner-box">
                                  <NTCreateOrEditAutTras
                                    formNT={formNT}
                                    setFormNT={setFormNT}
                                    setIsLoadingErrorData={setIsLoadingErrorData}
                                    errorsForm={errorsForm}
                                    setErrorsForm={setErrorsForm}
                                    validateformNT={validateformNT}
                                    documentTypesToSelect={documentTypesToSelect}
                                    roadTypesToSelect={roadTypesToSelect}
                                    communityToSelect={communityToSelect}
                                    expanded={expanded}
                                    optTypeToSelect={optTypeToSelect}
                                    hasbeenshared={hasbeenshared}
                                />
                                </div>
                              </AccordionDetails>
                              
                            </Accordion>
                          } 
                          {dest_tras_view && 
                            <Accordion className="accordionOptTras-root" expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                                disabled={!dest_tras_expand}
                                className="accordionOptTras-backcolor"
                              >
                                <Typography className="accordionOptTras-heading">{t('Text_FORM_DEST_TRAS')} : <span>{t('Text_FORM_DEST_TRAS_PROD')}</span></Typography>
                                <Typography className="accordionOptTras-secondaryHeading">
                                  {formNT.dest_tras_tradename!==undefined && formNT.dest_tras_tradename!==null && formNT.dest_tras_tradename!==""?formNT.dest_tras_tradename:t('Text_NOT_REPORTING')}
                                  {formNT.dest_tras_documentid!=="" && formNT.dest_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                  {formNT.dest_tras_documentid!=="" && formNT.dest_tras_street!=="" && !formNT.dest_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Dest_Tras_Required')} !!</span>:""}
                                  {errorsForm.dest_tras_email!==undefined && errorsForm.dest_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                  {(errorsForm.dest_tras_documentid!==undefined && errorsForm.dest_tras_documentid!=="") ||
                                  (errorsForm.dest_tras_tradename!==undefined && errorsForm.dest_tras_tradename!=="") ||
                                  (errorsForm.dest_tras_name!==undefined && errorsForm.dest_tras_name!=="") ||
                                  (errorsForm.dest_tras_contactname!==undefined && errorsForm.dest_tras_contactname!=="") ||
                                  (errorsForm.dest_tras_street!==undefined && errorsForm.dest_tras_street!=="") ||
                                  (errorsForm.dest_tras_phone!==undefined && errorsForm.dest_tras_phone!=="") ||
                                  (errorsForm.dest_tras_nima!==undefined && errorsForm.dest_tras_nima!=="") ||
                                  (errorsForm.dest_tras_cnae!==undefined && errorsForm.dest_tras_cnae!=="") ||
                                  (errorsForm.dest_tras_inscription!==undefined && errorsForm.dest_tras_inscription!=="") ||
                                  (errorsForm.dest_tras_opt!==undefined && errorsForm.dest_tras_opt!=="") ||
                                  (errorsForm.dest_tras_economicactivity!==undefined && errorsForm.dest_tras_economicactivity!=="") ||
                                  (errorsForm.dest_tras_licenseplate!==undefined && errorsForm.dest_tras_licenseplate!=="")
                                  ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="accordion-inner-box">
                                  <NTCreateOrEditDestTras
                                    formNT={formNT}
                                    setFormNT={setFormNT}
                                    setIsLoadingErrorData={setIsLoadingErrorData}
                                    errorsForm={errorsForm}
                                    setErrorsForm={setErrorsForm}
                                    validateformNT={validateformNT}
                                    documentTypesToSelect={documentTypesToSelect}
                                    roadTypesToSelect={roadTypesToSelect}
                                    communityToSelect={communityToSelect} 
                                    expanded={expanded} 
                                    optTypeToSelect={optTypeToSelect}
                                    hasbeenshared={hasbeenshared}
                                />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          }
                          {aut_dest_view &&   
                            <Accordion className="accordionOptTras-root" expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel5bh-content"
                                id="panel5bh-header"
                                disabled={!aut_dest_expand}
                                className="accordionOptTras-backcolor"
                              >
                                <Typography className="accordionOptTras-heading">{t('Text_FORM_DEST_TRAS')} : <span>{t('Text_FORM_DEST_TRAS_EMPR')}</span></Typography>
                                <Typography className="accordionOptTras-secondaryHeading">
                                {formNT.aut_dest_tradename!==undefined && formNT.aut_dest_tradename!==null && formNT.aut_dest_tradename!==""?formNT.aut_dest_tradename:t('Text_NOT_REPORTING')}
                                {formNT.aut_dest_documentid!=="" && formNT.aut_dest_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                {formNT.aut_dest_documentid!=="" && formNT.aut_dest_street!=="" && !formNT.aut_dest_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Dest_Required')} !!</span>:""}
                                {errorsForm.aut_dest_email!==undefined && errorsForm.aut_dest_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                {(errorsForm.aut_dest_documentid!==undefined && errorsForm.aut_dest_documentid!=="") ||
                                (errorsForm.aut_dest_tradename!==undefined && errorsForm.aut_dest_tradename!=="") ||
                                (errorsForm.aut_dest_name!==undefined && errorsForm.aut_dest_name!=="") ||
                                (errorsForm.aut_dest_contactname!==undefined && errorsForm.aut_dest_contactname!=="") ||
                                (errorsForm.aut_dest_street!==undefined && errorsForm.aut_dest_street!=="") ||
                                (errorsForm.aut_dest_phone!==undefined && errorsForm.aut_dest_phone!=="") ||
                                (errorsForm.aut_dest_nima!==undefined && errorsForm.aut_dest_nima!=="") ||
                                (errorsForm.aut_dest_cnae!==undefined && errorsForm.aut_dest_cnae!=="") ||
                                (errorsForm.aut_dest_inscription!==undefined && errorsForm.aut_dest_inscription!=="") ||
                                (errorsForm.aut_dest_opt!==undefined && errorsForm.aut_dest_opt!=="") ||
                                (errorsForm.aut_dest_economicactivity!==undefined && errorsForm.aut_dest_economicactivity!=="") ||
                                (errorsForm.aut_dest_licenseplate!==undefined && errorsForm.aut_dest_licenseplate!=="")
                                ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="accordion-inner-box">
                                   <NTCreateOrEditAutDest
                                    formNT={formNT}
                                    setFormNT={setFormNT}
                                    setIsLoadingErrorData={setIsLoadingErrorData}
                                    errorsForm={errorsForm}
                                    setErrorsForm={setErrorsForm}
                                    validateformNT={validateformNT}
                                    documentTypesToSelect={documentTypesToSelect}
                                    roadTypesToSelect={roadTypesToSelect}
                                    communityToSelect={communityToSelect}
                                    expanded={expanded}
                                    optTypeToSelect={optTypeToSelect}
                                    hasbeenshared={hasbeenshared}
                                />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          } 
                        </div> 
                        <div className="row p-2"> 
                          <div className="form-group">   
                            <h6 className="h7NewStyle mb-2">{t('Text_FORM_CHARAC')}</h6>
                            {/* Divider */}
                            <hr className="sidebar-divider d-none d-md-block"/>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_LER')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="codeler_code" 
                              name="codeler_code"
                              value={formNT.codeler_code}
                              inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px'}, maxLength: 20 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.codeler_code!=null?t(errorsForm.codeler_code):t('PlaceHolder_FORM_CODE_LER')}
                              placeholder={t('PlaceHolder_FORM_CODE_LER')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled={hasbeenshared} />
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id={i18n.language==='es'?"codeler_namees":"codeler_nameen"}
                              name={i18n.language==='es'?"codeler_namees":"codeler_nameen"}
                              value={i18n.language==='es'?formNT.codeler_namees:formNT.codeler_nameen}
                              inputProps={{ style: {width: i18n.language==='es'?413:435,  fontSize: '18px'}, maxLength: 200 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                              placeholder={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled/>
                            &nbsp;&nbsp;
                            <IconButton  size="small"  className="deletesmall-select-button" disabled={hasbeenshared} onClick={deleteDataCodeLer}>
                              <DeleteIcon style={{fontSize: 28}}/>
                            </IconButton> 
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_CodeLERS'))&&
                              <IconButton  size="small"  className="edit-select-button" disabled={hasbeenshared} onClick={searchFormCodeLer}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton>
                            }
                          </div>
                        </div>
                        {code_description_view && 
                          <div className="row p-2"> 
                            <div className="form-group">   
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_DESCRIPTION')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="description_code" 
                                name="description_code"
                                value={formNT.description_code}
                                inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px'}, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                label={errorsForm.description_code!=null?t(errorsForm.description_code):t('PlaceHolder_FORM_CODE_DESCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_CODE_DESCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm}
                                onChange={handleChangeDataEditForm}
                                disabled={!code_description_handle || hasbeenshared}/>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id={i18n.language==='es'?"description_namees":"description_nameen"}
                                name={i18n.language==='es'?"description_namees":"description_nameen"}
                                value={i18n.language==='es'?formNT.description_namees:formNT.description_nameen}
                                inputProps={{ style: {width: i18n.language==='es'?570:588,  fontSize: '18px'}, maxLength: 200 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                label={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                                placeholder={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm}
                                onChange={handleChangeDataEditForm}
                                disabled/>
                              &nbsp;&nbsp;
                              {code_description_handle&&
                                <>
                                  <IconButton  size="small"  className="deletesmall-select-button" disabled={hasbeenshared} onClick={deleteDataDescription}>
                                      <DeleteIcon style={{fontSize: 28}}/>
                                  </IconButton>
                                  &nbsp;&nbsp;
                                  {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Descriptions'))&&
                                      <IconButton  size="small"  className="edit-select-button" disabled={hasbeenshared}  onClick={searchFormDescription}>
                                        <SearchIcon style={{fontSize: 28}}/>
                                      </IconButton>
                                  }
                                </>
                              }
                            </div>
                          </div>
                        }  
                        {(code_treatmenttype_origin_view ||  code_processtype_origin_view) && 
                          <div className="row p-2"> 
                              <div className="form-group">   
                                { code_treatmenttype_origin_view &&
                                  <>
                                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_TREATMENT_ORIGIN')} :</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp; 
                                    <TextField
                                      id="treatmenttypeorigin_id"
                                      name="treatmenttypeorigin_id"
                                      value={ (formNT.treatmenttypeorigin_id === undefined || formNT.treatmenttypeorigin_id ===null || formNT.treatmenttypeorigin_id ===""
                                            || formNT.treatmenttypeorigin_id ==="0" || formNT.treatmenttypeorigin_id ===0)?0:formNT.treatmenttypeorigin_id}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      inputProps={{ style: {width: (code_treatmenttype_origin_view &&  code_processtype_origin_view)?i18n.language==='es'?166:178:i18n.language==='es'?685:697 ,  fontSize: '18px'}, maxLength: 100, }}
                                      variant="outlined"
                                      onBlur={handleBlurSelectTreatmentTypeOrigin}
                                      onChange={handleChangeSelectTreatmentTypeOrigin}
                                      disabled={!code_treatmenttype_origin_handle || hasbeenshared}
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formNT.treatmenttypeorigin_id === undefined || formNT.treatmenttypeorigin_id ===null || formNT.treatmenttypeorigin_id ===""
                                            || formNT.treatmenttypeorigin_id ==="0" || formNT.treatmenttypeorigin_id ===0)?0: formNT.treatmenttypeorigin_id
                                      }}>
                                      <option key={0} value=""/>
                                      {treatmenttypeToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                      </option>
                                      ))}
                                    </TextField>
                                    {code_processtype_origin_view && <>  &nbsp;&nbsp;&nbsp;&nbsp;</> }
                                  </>
                                }
                                { code_processtype_origin_view &&
                                  <>
                                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_PROCESS_ORIGIN')} :</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp; 
                                    <TextField
                                      id="processtypepeorigin_id"
                                      name="processtypepeorigin_id"
                                      value={ (formNT.processtypepeorigin_id === undefined || formNT.processtypepeorigin_id ===null || formNT.processtypepeorigin_id ===""
                                            || formNT.processtypepeorigin_id ==="0" || formNT.processtypepeorigin_id ===0)?0:formNT.processtypepeorigin_id}
                                      inputProps={{ style: {width: (code_treatmenttype_origin_view &&  code_processtype_origin_view)?i18n.language==='es'?166:178:i18n.language==='es'?685:697,  fontSize: '18px'}, maxLength: 100, }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      variant="outlined"
                                      onBlur={handleBlurSelectProcessTypeOrigin}
                                      onChange={handleChangeSelectProcessTypeOrigin}
                                      disabled={!code_processtype_origin_handle|| hasbeenshared}
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formNT.processtypepeorigin_id === undefined || formNT.processtypepeorigin_id ===null || formNT.processtypepeorigin_id ===""
                                            || formNT.processtypepeorigin_id ==="0" || formNT.processtypepeorigin_id ===0)?0: formNT.processtypepeorigin_id
                                      }}>
                                      <option key={0} value=""/>
                                      {processtypeToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                      </option>
                                      ))}
                                    </TextField>
                                  </>
                                }
                              </div>
                            </div>
                            
                        }
                        {(code_treatmenttype_destine_view ||  code_processtype_destine_view) && 
                          <div className="row p-2"> 
                              <div className="form-group">   
                                { code_treatmenttype_destine_view &&
                                  <>
                                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_TREATMENT_DESTINE')} :</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp; 
                                    <TextField
                                      id="treatmenttypedestine_id"
                                      name="treatmenttypedestine_id"
                                      value={ (formNT.treatmenttypedestine_id === undefined || formNT.treatmenttypedestine_id ===null || formNT.treatmenttypedestine_id ===""
                                            || formNT.treatmenttypedestine_id ==="0" || formNT.treatmenttypedestine_id ===0)?0:formNT.treatmenttypedestine_id}
                                      inputProps={{ style: {width: (code_treatmenttype_destine_view &&  code_processtype_destine_view)?i18n.language==='es'?155:138:i18n.language==='es'?672:655,  fontSize: '18px'}, maxLength: 100, }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      variant="outlined"
                                      onBlur={handleBlurSelectTreatmentTypeDestine}
                                      onChange={handleChangeSelectTreatmentTypeDestine}
                                      disabled={!code_treatmenttype_destine_handle || hasbeenshared}
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formNT.treatmenttypedestine_id === undefined || formNT.treatmenttypedestine_id ===null || formNT.treatmenttypedestine_id ===""
                                            || formNT.treatmenttypedestine_id ==="0" || formNT.treatmenttypedestine_id ===0)?0: formNT.treatmenttypedestine_id
                                      }}>
                                      <option key={0} value=""/>
                                      {treatmenttypeToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                      </option>
                                      ))}
                                    </TextField>
                                    {code_processtype_destine_view && <>&nbsp;&nbsp;&nbsp;&nbsp;</> }
                                  </>
                                }
                                { code_processtype_destine_view &&
                                  <>
                                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_PROCESS_DESTINE')} :</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp; 
                                    <TextField
                                      id="processtypedestine_id"
                                      name="processtypedestine_id"
                                      value={ (formNT.processtypedestine_id === undefined || formNT.processtypedestine_id ===null || formNT.processtypedestine_id ===""
                                            || formNT.processtypedestine_id ==="0" || formNT.processtypedestine_id ===0)?0:formNT.processtypedestine_id}
                                      inputProps={{ style: {width: (code_treatmenttype_destine_view &&  code_processtype_destine_view)?i18n.language==='es'?156:139:i18n.language==='es'?672:655,  fontSize: '18px'}, maxLength: 100, }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      variant="outlined"
                                      onBlur={handleBlurSelectProcessTypeDestine}
                                      onChange={handleChangeSelectProcessTypeDestine}
                                      disabled={!code_processtype_destine_handle || hasbeenshared}
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formNT.processtypedestine_id === undefined || formNT.processtypedestine_id ===null || formNT.processtypedestine_id ===""
                                            || formNT.processtypedestine_id ==="0" || formNT.processtypedestine_id ===0)?0: formNT.processtypedestine_id
                                      }}>
                                      <option key={0} value=""/>
                                      {processtypeToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                      </option>
                                      ))}
                                    </TextField>
                                  </>
                                }
                              </div>
                            </div>
                        }
                        {code_dangerousness_view && 
                          <div className="row p-2"> 
                            <div className="form-group">   
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_DANGEROUSNESS')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="dangerousness_id"
                                name="dangerousness_id"
                                value={ (formNT.dangerousness_id === undefined || formNT.dangerousness_id ===null || formNT.dangerousness_id ===""
                                      || formNT.dangerousness_id ==="0" || formNT.dangerousness_id ===0)?0:formNT.dangerousness_id}
                                inputProps={{ style: {width: i18n.language==='es'?741:730,  fontSize: '18px'}, maxLength: 100, }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                variant="outlined"
                                onBlur={handleBlurSelectDangerousness}
                                onChange={handleChangeSelectDangerousness}
                                disabled={!code_dangerousness_handle || hasbeenshared}
                                select
                                SelectProps={{
                                  native: true,
                                  value: (formNT.dangerousness_id === undefined || formNT.dangerousness_id ===null || formNT.dangerousness_id ===""
                                      || formNT.dangerousness_id ==="0" || formNT.dangerousness_id ===0)?0: formNT.dangerousness_id
                                }}>
                                <option key={0} value=""/>
                                {dangerousness.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees.substring(0,90):option.nameen.substring(0,90)}
                                </option>
                                ))}
                              </TextField>
                            </div>
                          </div>
                        }
                        <div className="row p-2"> 
                          <div className="form-group">   
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CHARAC_DANGER')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="charac_danger" 
                                name="charac_danger"
                                value={formNT.charac_danger}
                                inputProps={{ style: {width: i18n.language==='es'?397:392}, maxLength: 200 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.charac_danger!=null?t(errorsForm.charac_danger):t('PlaceHolder_FORM_CHARAC_DANGER')}
                                placeholder={t('PlaceHolder_FORM_CHARAC_DANGER')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm}
                                onChange={handleChangeDataEditForm}
                                disabled={!charac_danger_handle || hasbeenshared}/>
                          
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_AMOUNT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <NumericFormat 
                              thousandSeparator={','} 
                              decimalSeparator={'.'} 
                              decimalScale= {2}
                              fixedDecimalScale= {true}
                              allowNegative= {false}
                              isAllowed={withValueCap}
                              id="amount" 
                              name="amount"
                              suffix={" kg"}
                              value={formNT.amount}
                              label={errorsForm.amount!=null?t(errorsForm.amount):t('PlaceHolder_FORM_AMOUNT')}
                              placeholder={t('PlaceHolder_FORM_AMOUNT')}
                              inputProps={{ style: {width: i18n.language==='es'?200:200} }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              customInput={TextField}
                              onBlur={handleBlurDataEditFormAmount}
                              onChange={handleChangeDataEditFormAmount} 
                            />
                          </div>
                        </div> 
                        {rel_trans_view && 
                          <Accordion className="accordionOptTras-root" expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel6bh-content"
                              id="panel6bh-header"
                              disabled={!rel_trans_expand}
                              className="accordionOptTras-backcolor"
                            >
                                <Typography className="accordionOptTras-heading">{t('Text_FORM_TREATMENT_LATER')} : </Typography>
                                <Typography className="accordionOptTras-secondaryHeading">
                                  {formNT.rel_trans_tradename!==undefined && formNT.rel_trans_tradename!==null && formNT.rel_trans_tradename!==""?formNT.rel_trans_tradename:t('Text_NOT_REPORTING')}
                                  {formNT.rel_trans_documentid!=="" && formNT.rel_trans_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                  {formNT.rel_trans_documentid!=="" && formNT.rel_trans_street!=="" && !formNT.rel_trans_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Rel_Trans_Required')} !!</span>:""}
                                  {errorsForm.rel_trans_email!==undefined && errorsForm.rel_trans_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                  {(errorsForm.rel_trans_documentid!==undefined && errorsForm.rel_trans_documentid!=="") ||
                                  (errorsForm.rel_trans_tradename!==undefined && errorsForm.rel_trans_tradename!=="") ||
                                  (errorsForm.rel_trans_name!==undefined && errorsForm.rel_trans_name!=="") ||
                                  (errorsForm.rel_trans_contactname!==undefined && errorsForm.rel_trans_contactname!=="") ||
                                  (errorsForm.rel_trans_street!==undefined && errorsForm.rel_trans_street!=="") ||
                                  (errorsForm.rel_trans_phone!==undefined && errorsForm.rel_trans_phone!=="") ||
                                  (errorsForm.rel_trans_nima!==undefined && errorsForm.rel_trans_nima!=="") ||
                                  (errorsForm.rel_trans_cnae!==undefined && errorsForm.rel_trans_cnae!=="") ||
                                  (errorsForm.rel_trans_inscription!==undefined && errorsForm.rel_trans_inscription!=="") ||
                                  (errorsForm.rel_trans_opt!==undefined && errorsForm.rel_trans_opt!=="") ||
                                  (errorsForm.rel_trans_economicactivity!==undefined && errorsForm.rel_trans_economicactivity!=="") ||
                                  (errorsForm.rel_trans_licenseplate!==undefined && errorsForm.rel_trans_licenseplate!=="")
                                  ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="accordion-inner-box">
                                <NTCreateOrEditRelTrans
                                  formNT={formNT}
                                  setFormNT={setFormNT}
                                  setIsLoadingErrorData={setIsLoadingErrorData}
                                  errorsForm={errorsForm}
                                  setErrorsForm={setErrorsForm}
                                  validateformNT={validateformNT}
                                  documentTypesToSelect={documentTypesToSelect}
                                  roadTypesToSelect={roadTypesToSelect}
                                  communityToSelect={communityToSelect} 
                                  expanded={expanded}
                                  optTypeToSelect={optTypeToSelect}
                                  hasbeenshared={hasbeenshared} 
                              />
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        }
                        {resp_prod_view && 
                          <Accordion className="accordionOptTras-root" expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel7bh-content"
                              id="panel7bh-header"
                              disabled={!resp_prod_expand}
                              className="accordionOptTras-backcolor"
                            >
                              <Typography className="accordionOptTras-heading">{t('Text_FORM_TREATMENT_LATER')} : <span>{t('Text_FORM_ORI_TRAS_EMPR')}</span></Typography>
                              <Typography className="accordionOptTras-secondaryHeading">
                                {formNT.resp_prod_tradename!==undefined && formNT.resp_prod_tradename!==null && formNT.resp_prod_tradename!==""?formNT.resp_prod_tradename:t('Text_NOT_REPORTING')}
                                {formNT.resp_prod_documentid!=="" && formNT.resp_prod_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                                {formNT.resp_prod_documentid!=="" && formNT.resp_prod_street!=="" && !formNT.resp_prod_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Resp_Prod_Required')} !!</span>:""}
                                {errorsForm.resp_prod_email!==undefined && errorsForm.resp_prod_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                                {(errorsForm.resp_prod_documentid!==undefined && errorsForm.resp_prod_documentid!=="") ||
                                (errorsForm.resp_prod_tradename!==undefined && errorsForm.resp_prod_tradename!=="") ||
                                (errorsForm.resp_prod_name!==undefined && errorsForm.resp_prod_name!=="") ||
                                (errorsForm.resp_prod_contactname!==undefined && errorsForm.resp_prod_contactname!=="") ||
                                (errorsForm.resp_prod_street!==undefined && errorsForm.resp_prod_street!=="") ||
                                (errorsForm.resp_prod_phone!==undefined && errorsForm.resp_prod_phone!=="") ||
                                (errorsForm.resp_prod_nima!==undefined && errorsForm.resp_prod_nima!=="") ||
                                (errorsForm.resp_prod_cnae!==undefined && errorsForm.resp_prod_cnae!=="") ||
                                (errorsForm.resp_prod_inscription!==undefined && errorsForm.resp_prod_inscription!=="") ||
                                (errorsForm.resp_prod_opt!==undefined && errorsForm.resp_prod_opt!=="") ||
                                (errorsForm.resp_prod_economicactivity!==undefined && errorsForm.resp_prod_economicactivity!=="") ||
                                (errorsForm.resp_prod_licenseplate!==undefined && errorsForm.resp_prod_licenseplate!=="")
                                ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="accordion-inner-box">
                                <NTCreateOrEditRespProd
                                  formNT={formNT}
                                  setFormNT={setFormNT}
                                  setIsLoadingErrorData={setIsLoadingErrorData}
                                  errorsForm={errorsForm}
                                  setErrorsForm={setErrorsForm}
                                  validateformNT={validateformNT}
                                  documentTypesToSelect={documentTypesToSelect}
                                  roadTypesToSelect={roadTypesToSelect}
                                  communityToSelect={communityToSelect} 
                                  expanded={expanded}
                                  optTypeToSelect={optTypeToSelect}
                                  hasbeenshared={hasbeenshared}
                                />
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        } 
                      </div>
                    </>:
                      <LoadingNews/>
                  }
              </form>
            </Box>
            <br/>
            <NTSearchCodeLers
              showModalSearchCodeLERS={showModalSearchCodeLERS}
              setShowModalSearchCodeLERS={setShowModalSearchCodeLERS} 
              setFormNT={setFormNT}
            />
             <NTSearchDescriptions
              showModalSearchDescriptions={showModalSearchDescriptions}
              setShowModalSearchDescriptions={setShowModalSearchDescriptions} 
              setFormNT={setFormNT}
            />
           
          </div>
        //* End Page Content *//
      ) :  null }
    </>
    )    
  }